// All site copy. Keep keys identical across languages.
// Languages: en, fr, el, pl

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "el", label: "Ελληνικά", short: "EL" },
  { code: "pl", label: "Polski", short: "PL" },
];

export const SITE = {
  couple: "Elias & Magdalena",
  coupleShort: "Eli & Mag",
  dateNumeric: "19.05.2027",
  dateISO: "2027-05-19",
  location: "Ammos Kalambouri Beach · Cyprus",
};

const en = {
  meta: {
    htmlLang: "en",
    dateLong: "Wednesday, 19 May 2027",
  },
  landing: {
    overline: "A private wedding journal",
    title: "Elias & Magdalena",
    subtitle: "Choose your language",
    footer: "19 May 2027 · Ammos Kalambouri Beach · Cyprus",
  },
  gate: {
    overline: "Private screening",
    title: "A few words for those we love",
    body: "This site is reserved for our guests. Please enter the password we shared with you on your invitation.",
    placeholder: "Password",
    submit: "Continue",
    error: "That password is not quite right. Please try again.",
    forgot: "If you can’t find the password, please contact us directly.",
  },
  common: { cancel: "Cancel", save: "Save", back: "Back" },
  nav: {
    home: "Home",
    story: "Our Story",
    schedule: "Schedule",
    travel: "Travel",
    rsvp: "RSVP",
    gallery: "Gallery",
    upload: "Share photos",
    guestbook: "Guestbook",
    faq: "FAQ",
    gifts: "Gifts",
    dj: "DJ",
    menu: "Menu",
    close: "Close",
    logout: "Sign out",
  },
  home: {
    heroOverline: "19 · 05 · 2027  ·  Cyprus",
    heroTitle: "Elias & Magdalena",
    heroSubtitle: "are getting married",
    heroLocation: "Ammos Kalambouri Beach · Cyprus",
    heroCta: "Begin",
    scroll: "Scroll",
    countdownOverline: "Counting the days",
    countdownTitle: "Until we say yes.",
    countdownDays: "Days",
    countdownHours: "Hours",
    countdownMinutes: "Minutes",
    countdownSeconds: "Seconds",
    countdownStarted: "Today is the day.",
    countdownAnnivOverline: "Of us",
    countdownYearOfUs: "year of us",
    countdownYearsOfUs: "years of us",
    countdownMonthOfUs: "month of us",
    countdownMonthsOfUs: "months of us",
    countdownDayOfUs: "day of us",
    countdownDaysOfUs: "days of us",
    weatherOverline: "The forecast",
    weatherHistoricalTitle: "Cyprus in May.",
    weatherForecastTitle: "The forecast for our day.",
    weatherHistoricalNote: "Typical values for mid-late May on the Cypriot coast.",
    weatherForecastNote: "Live forecast from Open-Meteo · updates hourly.",
    weatherHigh: "High",
    weatherLow: "Low",
    weatherSea: "Sea",
    weatherSunshine: "Sunshine",
    weatherRain: "Rain",
    weatherSunrise: "Sunrise",
    weatherSunset: "Sunset",
    weatherUV: "UV index",
    weatherSunny: "Sunny",
    weatherMostlySunny: "Mostly sunny",
    weatherPartlyCloudy: "Partly cloudy",
    weatherCloudy: "Cloudy",
    weatherRainy: "Rain expected",
    weatherStormy: "Stormy",
    weatherLocation: "Ammos Kalambouri · Cyprus",
    addToCalendar: "Add to calendar",
    calendarGoogle: "Google Calendar",
    calendarApple: "Apple / iCal (.ics)",
    calendarOutlook: "Outlook",
    calendarEventTitle: "Elias & Magdalena — Wedding",
    calendarEventDetails: "The wedding of Eli & Mag on the Cypriot coast. Dress: linen, no heels, sun-ready. See the site for schedule and travel.",
    welcomeOverline: "A note from us",
    welcomeTitle: "No plan. No shoes. Just the sea, and you.",
    welcomeBody:
      "We're getting married on a quiet stretch of Cypriot shore — Eli, Mag, Max and the people who shaped us. No fairy-tale, no ball gown, no first dance, no tight shoes. Linen, souvlaki, sunset, sea breeze. Bring yourself, bring your camera, bring a light sweater for the evening.",
    tipOfTheDay: "Andreas' tip of the day",
    storyOverline: "Our story",
    storyTitle: "From Warsaw and France to Cyprus — and many many flights of stubbornness.",
    storyBody:
      "A friendship in 2022, ten plane tickets in three months, rejections for love in 2024 then so many dates in 2025, three rings, two dogs, an 11-year-old named Max, a quiet civil union — and now, the beach.",
    storyCta: "Read our story",
    scheduleOverline: "The day",
    scheduleTitle: "A slow, sun-soaked celebration.",
    scheduleCta: "See the schedule",
    travelOverline: "Getting here",
    travelTitle: "Cyprus, in May, at her quietest.",
    travelBody:
      "We have gathered everything you need to find your way to Ammos Kalambouri — airports, hotels, drivers, and the small details in between.",
    travelCta: "Travel & stay",
    rsvpOverline: "Please reply",
    rsvpTitle: "Will you stand with us?",
    rsvpBody: "Kindly let us know by 1 March 2027.",
    rsvpCta: "Reply now",
  },
  story: {
    overline: "Our story · a photo album",
    title: "Warsaw → Cyprus, the long way round.",
    intro:
      "Not a highlight reel. A scrapbook. Thirteen chapters, in order, with the photos we still keep on our phones. Read it at your own pace — there is no test at the end.",
    closingOverline: "— And now —",
    beats: [
      {
        chapter: "Chapter I · September 2022",
        title: "Warsaw, a first time.",
        body:
          "We met for the first time in Warsaw. We became friends.\nEli already had something for Mag — not love, but something stubborn enough to remember.\nThen, slowly, we lost touch.",
      },
      {
        chapter: "Chapter II · October → December 2024",
        title: "Found again. Sort of.",
        body:
          "Two years later, Eli started finding excuses to fly back to Warsaw. There were stories — the real reason was Mag. In three months he visited her over ten times.\nOn 11 October 2024 he fell madly in love. Why her? Why Poland? Who knows.\nMag, meanwhile, didn't want a man in her life and was very politely going \"fuck you\" to the whole thing. It took many trips, many friendly dinners, a lot of pushing — before she finally said yes to a real date.",
      },
      {
        chapter: "Chapter III · January 2025",
        title: "First dates, and a third heartbeat.",
        body:
          "Eli was introduced to Max — Mag's son, and the third heartbeat of this story.\nMag let her guard down a little. Two dinners at Elixir in one week, for her birthday. Finally, a bit of romance.",
      },
      {
        chapter: "Chapter IV · February 2025",
        title: "First Valentine's, and a hand in the snow.",
        body:
          "Our first Valentine's together in Warsaw — cinema, dinner, the whole thing. Then the next day, the three of us went to Gdańsk.\nSomewhere in there, someone wrote ELI ❤ MAX in the snow on a windshield. It might be our favourite photo so far.",
      },
      {
        chapter: "Chapter V · March → April 2025",
        title: "A ring, and a seat on the train.",
        body:
          "More trips to Warsaw. More dates. Eli decided to leave France for Cyprus to start building a home for this new family.\nBefore leaving, he gave Mag a ring — not the ring, just a ring — and asked her to keep him \"a seat on the train\".",
      },
      {
        chapter: "Chapter VI · May 2025",
        title: "Cyprus, the first time as three.",
        body:
          "Max and Mag flew in for a holiday. The Mediterranean did its thing. We became a family by the sea.\nEli gave Mag a second ring — to make us official partners.\nA week after that holiday, Mag surprised Eli with a one-day surprise trip back to Cyprus. Just to say hi.",
      },
      {
        chapter: "Chapter VII · 9 June 2025",
        title: "A yes, at a small table in Warsaw.",
        body:
          "More dates in Warsaw. Mag had said \"not now, not yet\". Eli, stubborn, asked anyway.\nBetween a shared dessert and a painted wall that read volere è potere — to want is to be able — Magdalena said yes.\nAt the end of June, Mag flew to Cyprus with her friends Danka and Anka. Danka accepted to be a witness.",
      },
      {
        chapter: "Chapter VIII · July 2025",
        title: "Three of us, two dogs, one ferry of suitcases.",
        body:
          "Mag, Max and our two dogs moved to Cyprus.\nIt was a lot of logistics. Paperwork, plane crates, an airport reunion that nearly didn't fit in the photo. They made it.",
      },
      {
        chapter: "Chapter IX · July → September 2025",
        title: "Romania, Malta, and day trips home.",
        body:
          "Eli was working away most of the summer. It was hard.\nHe escaped to Cyprus on day trips just to hug Mag and Max. They flew out to see him in Malta. We made it work, one short flight at a time.",
      },
      {
        chapter: "Chapter X · October 2025",
        title: "Free — and a Disneyland sky.",
        body:
          "Mag got her divorce in Warsaw. The path was finally free for the wedding.\nWe celebrated as a family, the only way that made sense: Disneyland Paris.",
      },
      {
        chapter: "Chapter XI · December 2025 → January 2026",
        title: "First Christmas. One camper. Seven countries.",
        body:
          "Our first Christmas together — and we did the responsible thing: rented a camper and drove through Italy, Austria, Slovenia, Croatia, back into Italy, Switzerland, France.\nWe ate everything. We froze. We laughed a lot. New Year's was in Paris.",
      },
      {
        chapter: "Chapter XII · February 2026",
        title: "Armenia, hearts and a jacuzzi.",
        body:
          "Valentine's for two — in Armenia. A hotel lobby covered in red heart balloons. A jacuzzi with another red heart balloon. We are not subtle people.",
      },
      {
        chapter: "Chapter XIII · 15 April 2026",
        title: "Quietly, officially us.",
        body:
          "We quietly entered a civil union with two witnesses — partly to start changing Max's surname, partly because Eli is stubborn and couldn't wait.\nThen back to Cyprus, back to the slow good life. Building a home. Counting down to May.",
      },
    ],
    closing: "And in May 2027, we'll meet you on the beach.",
  },
  schedule: {
    overline: "The day",
    title: "19 May 2027 — Ammos Kalambouri, Cyprus.",
    intro: "No plan, no schedule. Children and spontaneity very welcome.",
    items: [
      { time: "15:30", title: "Ceremony", place: "Ammos Kalambouri Beach", note: "Barefoot on the sand. The sea does the rest. Arrive a little earlier if you can — and tell us if you need help getting there." },
      { time: "After", title: "Souvlaki, music, the sea", place: "On the beach", note: "We sit, we eat, we dance, we chat — until sunset, or midnight, or whenever the night decides. Bring a light jacket or sweater; the breeze cools after dark." },
    ],
    mapCaption: "Map · Ammos Kalambouri Beach",
    mapOpen: "Open in Google Maps →",
    dressOverline: "Dress code (sort of)",
    dressTitle: "Officially: no code. Practically: linen.",
    dressBody:
      "Ladies — leave the ball gowns, updos and heels at home. Pack a swimsuit and a light beach dress in sea colours; let the sun do your makeup. Gentlemen — keep the tuxedo in the closet. Linen, 7/8 trousers, comfortable elegant shoes, sunscreen. No tights, no plastic. Just the island and you.",
  },
  travel: {
    overline: "Travel & accommodation",
    title: "Finding Cyprus.",
    intro: "Everything you need to arrive easily — and stay a little longer.",
    tabs: { flights: "Flights", stay: "Where to stay", transport: "Getting around" },
    flights: {
      title: "Airports",
      body: "The closest international airport is Larnaca (LCA, ~1h drive). Paphos (PFO) is further. Both are well-served from London, Paris, Athens, Warsaw, and most major European hubs.",
      tip: "Booking by January usually offers the calmest fares.",
    },
    stay: {
      title: "Where to stay",
      body: "We've arranged a few options near the venue for our guests. Tell us in your RSVP if you'd like accommodation help — we'll send you the details directly.",
      list: [],
    },
    transport: {
      title: "Getting around",
      body: "Cyprus drives on the left. A rental car is the easiest way to move between the venue and your hotel. We will arrange shuttle buses on the day of the wedding from a central pickup point.",
      taxi: "Trusted local drivers: we will share contacts closer to the date.",
    },
    addresses: {
      title: "Key addresses",
      venue: "Ammos Kalambouri Beach, Pegeia, Cyprus",
      contact: "For anything practical, write to eliandmag@gmail.com",
    },
  },
  rsvp: {
    overline: "There will be a wedding.",
    title: "Will you come to the wedding in Cyprus?",
    deadline: "Kindly reply within one month of receiving your invitation.",
    intro:
      "When? 19.05.2027. Where? 📍 Ammos Kalambouri beach, Cyprus.\nBe our guest and help us plan that day. Our guests are coming from Cyprus, Poland, France, the UK, Italy, Malta, the USA…",
    summary: "Summary",
    errorRequired: "Name and email are required.",
    // Lookup + edit
    alreadyReplied: "Already replied?",
    findMyReply: "Find and edit my reply",
    lookupIntro: "Type the full name you used the first time — we'll load your answer so you can change anything.",
    lookupPlaceholder: "e.g. Anna Kowalska",
    lookupCta: "Find my reply",
    foundToast: "Found it — you can edit anything below.",
    notFoundToast: "No reply under that name yet. Check the spelling or start a fresh one below.",
    editKicker: "Editing your reply",
    editTitle: "Change of plan?",
    editIntro: "Your existing reply is prefilled below. Change anything and hit save — Andreas will note it, siga siga.",
    editBadge: "Editing your existing reply",
    editNameHint: "Keep the same name — it's how we find your reply.",
    editCancelledToast: "Editing cancelled — form is fresh.",
    saveEdit: "Save changes",
    editAgain: "Edit again",
    errorNameMismatch: "That name doesn't match your original reply. Type it exactly as before.",
    updatedTitle: "Your reply was updated",
    updatedBody: "Your changes are saved. Andreas noted them, siga siga.",
    fields: {
      name: "Full name",
      email: "Email",
      attending: "Will you come?",
      attendingYes: "Yes, I'll be there",
      attendingNo: "Sadly, I cannot make it",
      guests: "How many will you be?",
      kids: "…of which are kids",
      kidsHint: "Included in the total above",
      accommodation: "Accommodation in Cyprus?",
      accommodationNeed: "Yes — please help me find a place",
      accommodationOwn: "No — I'll book on my own",
      accommodationNo: "Not needed",
      allergies: "Food allergies?",
      arrivalDate: "Arrival in Cyprus",
      departureDate: "Departure from Cyprus",
      arrivalHint: "Optional — helps us plan pickups & dinners.",
      song: "A song we should play",
      songPlaceholder: "Fleetwood Mac – Dreams",
      songHint: "Artist & title works best. We add it to the shared playlist.",
      message: "A message for us",
    },
    menu: {
      overline: "Wedding menu",
      title: "Pre-order your bites (optional).",
      intro: "Pick what you'd like on the day — sandwiches, burgers, drinks. Add as many as you like; we prepare it for you. Skip this if you'd rather decide on the day.",
      empty: "Nothing added yet.",
      totalOne: "item selected",
      totalMany: "items selected",
      clear: "Clear order",
      add: "Add",
      remove: "Remove",
    },
    submit: "Send reply",
    sending: "Sending…",
    successTitle: "Thank you.",
    successBody: "Your reply has reached us. We are looking forward to celebrating with you.",
    successAnother: "Send another reply",
    errorGeneric: "Something went wrong. Please try again in a moment.",
  },
  gallery: {
    overline: "Gallery",
    title: "Frames from the journey.",
    intro: "A quiet archive — moments shared by us and by you.",
    empty: "No photos yet. After the wedding, this page will fill up with frames shared by our guests.",
    close: "Close",
    prev: "Previous",
    next: "Next",
    downloadAll: "Download all photos",
    preparing: "Preparing your download…",
    viewGrid: "Grid",
    viewTimeline: "Timeline",
    timelineFallback: "uploaded",
    timelineNoExifTooltip: "No original timestamp \u2014 using upload time",
  },
  upload: {
    overline: "Share your photos",
    title: "Help us keep the memory.",
    body: "Choose photos from your day — they will appear in our shared gallery within seconds.",
    nameLabel: "Your name (optional)",
    choose: "Choose photos",
    uploading: "Uploading…",
    successTitle: "Thank you for sharing.",
    successBody: "Your photos are now part of our journal.",
    addAnother: "Share more",
    viewGallery: "View gallery",
    errorType: "This file type is not supported.",
    errorGeneric: "Upload failed. Please try once more.",
  },
  guestbook: {
    overline: "Love letters",
    title: "Leave us a note.",
    intro: "A small, open notebook for anyone who wants to write to us — before the day, or long after.",
    nameLabel: "Your name",
    namePlaceholder: "How you'd like to be signed",
    messageLabel: "Your message",
    messagePlaceholder: "Something short, something silly, something serious — anything is welcome.",
    submit: "Sign the book",
    sending: "Signing…",
    successToast: "Thank you for signing our book.",
    errorEmpty: "Please add a name and a message.",
    errorGeneric: "We couldn't save your note. Please try again.",
    emptyTitle: "No notes yet.",
    emptyBody: "Be the first to leave a few words.",
    counter: "characters left",
  },
  faq: {
    overline: "FAQ",
    title: "Serious questions, lightly answered.",
    items: [
      { q: "Is there a dress code?", a: "Officially no. Practically: leave the ball gowns, tuxedos, heels and updos at home. Ladies — pack a swimsuit and a light beach dress in sea colours, and let the sun do your makeup. Gentlemen — linen, 7/8 trousers, comfortable elegant shoes, sunscreen. The wedding is on the beach. No tights, no plastic. Just the island and you." },
      { q: "What time should I arrive?", a: "Ceremony at 15:30 on Ammos Kalambouri beach. Come a little earlier if you can. After: we sit, eat souvlaki, dance and chat until sunset or midnight — whichever wins. Bring a light jacket; the sea breeze cools after dark." },
      { q: "Is there a schedule? A first dance? A reception?", a: "Nope. Our wedding has no plan, no schedule. Children and spontaneity very welcome. There will be beautiful photos, a barbecue, music, the sea — and you." },
      { q: "Can you help with travel and accommodation?", a: "Yes. If you need a ride from the airport or want to extend your stay, just tell us — we'll help. Our small team in Cyprus, Malta, France and Poland is on standby. Halloumi will connect us all." },
      { q: "Are children welcome?", a: "Absolutely. Bring them. Spontaneity welcome." },
      { q: "What if I'm worried about my outfit, hair or makeup?", a: "Relax. The sun will take care of your makeup, the wind will style your hair, and you won't need beach shoes. A light, airy summer dress in sea colours will be perfect." },
      { q: "I don't like weddings, ties or tight shoes.", a: "Same. Throw on linen, skirts or shorts and a casual shirt. Forget the shoes. There will be a barbecue and great music. You'll be fine." },
      { q: "How can I help?", a: "Share your photos and videos from the day — upload them right here on the site so we can build a real album together. The creative community in this group is enormous; please use it." },
      { q: "If something's missing, who do I tell?", a: "Write or call us anytime. If you have an idea for what's missing on this site, or how we can do better, let us know — we read everything." },
    ],
  },
  footer: {
    lineOne: "Elias & Magdalena",
    lineTwo: "19 May 2027 · Ammos Kalambouri Beach · Cyprus",
    lineThree: "With love, in four languages.",
  },
  gifts: {
    kicker: "A gift for our day",
    title: "Help us build a home.",
    intro: "Your presence is the true gift. If you'd like to contribute towards our honeymoon, the details below are the ones we love most — bank transfer and Revolut mean every cent reaches us, without card fees.",
    progressOne: "friend has contributed so far. Thank you.",
    progressMany: "friends have contributed so far. Thank you.",
    preferredKicker: "Our preferred way",
    preferredTitle: "Bank transfer or Revolut.",
    preferredNote: "No card fees, no middlemen. Any currency below works — pick whichever is cheapest for your bank.",
    copyHandle: "Copy link",
    openRevolut: "Open",
    linkCopied: "Revolut link copied",
    cardKicker: "Or, if it's easier",
    cardTitle: "Pay by card.",
    cardNote: "A secure card payment via Stripe. There's a small processing fee — if you can, the bank details above are gentler on us both.",
    amountLabel: "Amount",
    amountHint: "Any amount from €5 to €5,000.",
    nameLabel: "Your name (optional)",
    messageLabel: "A private note to us (optional)",
    messagePrivate: "Only we will see this — it will never appear publicly.",
    payCta: "Continue to Stripe",
    opening: "Opening Stripe…",
    secure: "Secure payment · Stripe · 3D-Secure supported",
    errAmount: "Please enter an amount of at least €5.",
    errStart: "Payment could not start. Please try again in a moment.",
    cancelled: "Payment cancelled. No charge was made.",
    thanksTitle: "Thank you.",
    thanksConfirming: "Confirming…",
    thanksBody: "Your gift lands with us in Cyprus with a hug from us both. We can't wait to see you in May.",
    thanksWait: "Just a moment while Stripe confirms the payment.",
    thanksHome: "Back to the site",
  },
  dj: {
    kicker: "The DJ booth",
    title: "Request a song.",
    intro: "Type a song, hit send. It lands on the wedding playlist within seconds. Dance with us.",
    songLabel: "Song title (add the artist if you can)",
    songPlaceholder: "Dancing Queen — ABBA",
    nameLabel: "Your name (optional — appears below)",
    namePlaceholder: "Marie",
    sendCta: "Send to the DJ",
    sending: "Sending…",
    helper: "Auto-added to the Spotify playlist · duplicates are skipped",
    addedKicker: "Added",
    dupKicker: "Already there",
    openInSpotify: "Open",
    recentKicker: "On the playlist",
    recentTitle: "Recently added by our guests.",
    recentSuffix: "so far",
    recentEmpty: "No songs yet. Be the first.",
    by: "By",
    toastAdded: "On the playlist. Thank you!",
    toastDuplicate: "Already there — good taste.",
    toastNotFound: "We couldn't find that one — try adding the artist.",
    toastQueued: "Got your request!",
    errTooShort: "Type a song title (at least 2 characters).",
    errGeneric: "Something went wrong. Try again.",
    nowPlaying: "Playing now",
    yourSongPlaying: "Your song is playing",
  },
  ribbon: {
    ceremonyIn: "Ceremony in",
    beach: "Ammos Kalambouri Beach",
    veryClose: "Grab a spot on the sand. Ceremony very soon.",
    nowCeremony: "Now: the ceremony. The sea does the rest.",
    reception: "Souvlaki. Music. The sea. Toast with us.",
    party: "One last dance — the night decides.",
  },
  geo: {
    prompt: {
      kicker: "Where are you?",
      title: "Share your location for a personalised welcome.",
      body: "We'll give you the right info depending on how close you are to Ammos Kalambouri. This feature only works if you allow location tracking.",
      allow: "Allow",
      later: "Later",
    },
    denied: {
      kicker: "No worries",
      title: "Too bad!",
      body: "You can always find directions on the Travel page.",
      cta: "Travel page",
    },
    atVenue: {
      kicker: "You made it",
      title: "Welcome. Grab a cocktail.",
      body: "The ceremony is at 15:30 on the beach \u2014 follow the flowers.",
    },
    nearby: {
      kicker: "Almost there",
      title: "Welcome to Cyprus.",
      body: "Coffee before the ceremony? We start at 15:30 sharp on the sand \u2014 arrive a little earlier.",
    },
    onIsland: {
      kicker: "On the island",
      title: "You're almost here.",
      body: "Ceremony at 15:30 sharp on Ammos Kalambouri Beach \u2014 please arrive a little earlier.",
    },
    faraway: {
      kicker: "See you soon",
      title: "Safe travels.",
      body: "The ceremony starts at 15:30 on 19 May 2027 \u2014 plan to arrive a little before. Travel details on the Travel page.",
    },
  },
  milestones: {
    overline: "Our numbers so far",
    title: "A love, measured in seconds.",
    body: "Small numbers that keep growing between us. From the first coffee to the vows we'll say in Cyprus.",
    items: {
      met: "The day we met",
      firstDate: "Our first \u2018real\u2019 date",
      proposal: "Eli asked, Mag said yes",
      movedIn: "The day we moved in together",
      civilPartnership: "Our civil partnership",
    },
  },
};

const fr = {
  meta: { htmlLang: "fr", dateLong: "Mercredi 19 mai 2027" },
  landing: {
    overline: "Un journal de mariage privé",
    title: "Elias & Magdalena",
    subtitle: "Choisissez votre langue",
    footer: "19 mai 2027 · Plage d’Ammos Kalambouri · Chypre",
  },
  gate: {
    overline: "Projection privée",
    title: "Quelques mots pour ceux que nous aimons.",
    body: "Ce site est réservé à nos invités. Veuillez saisir le mot de passe figurant sur votre invitation.",
    placeholder: "Mot de passe",
    submit: "Continuer",
    error: "Mot de passe incorrect. Veuillez réessayer.",
    forgot: "Si vous ne le trouvez plus, contactez-nous directement.",
  },
  common: { cancel: "Annuler", save: "Enregistrer", back: "Retour" },
  nav: { home: "Accueil", story: "Notre histoire", schedule: "Programme", travel: "Voyage", rsvp: "RSVP", gallery: "Galerie", upload: "Partager des photos", guestbook: "Livre d'or", faq: "FAQ", gifts: "Cadeaux", dj: "DJ", menu: "Menu", close: "Fermer", logout: "Se déconnecter" },
  home: {
    heroOverline: "19 · 05 · 2027  ·  Chypre",
    heroTitle: "Elias & Magdalena",
    heroSubtitle: "se marient",
    heroLocation: "Plage d’Ammos Kalambouri · Chypre",
    heroCta: "Entrer",
    scroll: "Faire défiler",
    countdownOverline: "Le compte à rebours",
    countdownTitle: "Jusqu'à notre oui.",
    countdownDays: "Jours",
    countdownHours: "Heures",
    countdownMinutes: "Minutes",
    countdownSeconds: "Secondes",
    countdownStarted: "C'est aujourd'hui.",
    countdownAnnivOverline: "De nous",
    countdownYearOfUs: "an de nous",
    countdownYearsOfUs: "ans de nous",
    countdownMonthOfUs: "mois de nous",
    countdownMonthsOfUs: "mois de nous",
    countdownDayOfUs: "jour de nous",
    countdownDaysOfUs: "jours de nous",
    weatherOverline: "La météo",
    weatherHistoricalTitle: "Chypre en mai.",
    weatherForecastTitle: "La météo de notre jour.",
    weatherHistoricalNote: "Moyennes pour la seconde moitié de mai sur la côte chypriote.",
    weatherForecastNote: "Prévisions en direct via Open-Meteo · mises à jour à l'heure.",
    weatherHigh: "Max.",
    weatherLow: "Min.",
    weatherSea: "Mer",
    weatherSunshine: "Ensoleillement",
    weatherRain: "Pluie",
    weatherSunrise: "Lever du soleil",
    weatherSunset: "Coucher du soleil",
    weatherUV: "Indice UV",
    weatherSunny: "Ensoleillé",
    weatherMostlySunny: "Plutôt ensoleillé",
    weatherPartlyCloudy: "Partiellement nuageux",
    weatherCloudy: "Nuageux",
    weatherRainy: "Pluie attendue",
    weatherStormy: "Orageux",
    weatherLocation: "Ammos Kalambouri · Chypre",
    addToCalendar: "Ajouter au calendrier",
    calendarGoogle: "Google Agenda",
    calendarApple: "Apple / iCal (.ics)",
    calendarOutlook: "Outlook",
    calendarEventTitle: "Elias & Magdalena — Mariage",
    calendarEventDetails: "Le mariage d'Eli & Mag sur la côte chypriote. Tenue : lin, sans talons, prête pour le soleil. Détails sur le site.",
    welcomeOverline: "Un mot de nous",
    welcomeTitle: "Pas de plan. Pas de chaussures. La mer, et vous.",
    welcomeBody:
      "Nous nous marions sur une portion calme du littoral chypriote — Eli, Mag, Max et celles et ceux qui nous ont façonnés. Pas de conte de fées, pas de robe à crinoline, pas de première danse. Lin, souvlaki, coucher de soleil, vent marin. Apportez-vous, votre appareil photo et un petit pull pour le soir.",
    tipOfTheDay: "L'astuce d'Andreas",
    storyOverline: "Notre histoire",
    storyTitle: "De Varsovie et la France à Chypre — et beaucoup, beaucoup de vols d'entêtement.",
    storyBody: "Une amitié en 2022, dix billets d'avion en trois mois, des refus pour amour en 2024 puis beaucoup de rendez-vous en 2025, trois bagues, deux chiens, un Max de 11 ans, une union civile discrète — et maintenant, la plage.",
    storyCta: "Lire notre histoire",
    scheduleOverline: "La journée",
    scheduleTitle: "Une célébration lente, baignée de soleil.",
    scheduleCta: "Voir le programme",
    travelOverline: "Venir",
    travelTitle: "Chypre, en mai, à son plus calme.",
    travelBody: "Nous avons rassemblé tout ce dont vous avez besoin pour rejoindre Ammos Kalambouri — aéroports, hôtels, chauffeurs et petits détails.",
    travelCta: "Voyage & hébergement",
    rsvpOverline: "Merci de répondre",
    rsvpTitle: "Serez-vous à nos côtés ?",
    rsvpBody: "Merci de répondre avant le 1ᵉʳ mars 2027.",
    rsvpCta: "Répondre",
  },
  story: {
    overline: "Notre histoire · un album",
    title: "Varsovie → Chypre, par le plus long chemin.",
    intro: "Pas un best-of. Un album. Treize chapitres, dans l'ordre, avec les photos qu'on garde encore sur nos téléphones. À lire à votre rythme.",
    closingOverline: "— Et maintenant —",
    beats: [
      { chapter: "Chapitre I · Septembre 2022", title: "Varsovie, une première fois.", body: "Nous nous sommes rencontrés à Varsovie. Nous sommes devenus amis.\nEli avait déjà quelque chose pour Mag — pas de l'amour, mais quelque chose d'assez têtu pour s'en souvenir.\nPuis, doucement, nous nous sommes perdus de vue." },
      { chapter: "Chapitre II · Octobre → Décembre 2024", title: "Retrouvés. Plus ou moins.", body: "Deux ans plus tard, Eli a trouvé des prétextes pour revenir à Varsovie. Officiellement, il y avait des raisons — en vrai, c'était Mag. En trois mois, plus de dix voyages.\nLe 11 octobre 2024, il en est tombé fou amoureux. Pourquoi elle ? Pourquoi la Pologne ? On ne sait pas.\nMag, elle, ne voulait pas d'homme dans sa vie et répondait poliment \"va te faire voir\" à tout ça. Il a fallu beaucoup de voyages, beaucoup de dîners \"entre amis\", beaucoup d'insistance — avant qu'elle accepte enfin un vrai rendez-vous." },
      { chapter: "Chapitre III · Janvier 2025", title: "Premiers rendez-vous, et un troisième cœur.", body: "Eli a rencontré Max — le fils de Mag, le troisième cœur de cette histoire.\nMag a baissé un peu la garde. Deux dîners chez Elixir en une semaine, pour son anniversaire. Enfin un peu de romance." },
      { chapter: "Chapitre IV · Février 2025", title: "Première Saint-Valentin, et une main dans la neige.", body: "Notre première Saint-Valentin à Varsovie — cinéma, dîner, tout. Le lendemain, nous sommes partis tous les trois à Gdańsk.\nQuelque part dans tout ça, quelqu'un a écrit ELI ❤ MAX dans la neige sur un pare-brise. C'est peut-être notre photo préférée." },
      { chapter: "Chapitre V · Mars → Avril 2025", title: "Une bague, et une place dans le train.", body: "Encore des voyages à Varsovie. Encore des rendez-vous. Eli a décidé de quitter la France pour Chypre, pour préparer un foyer à cette nouvelle famille.\nAvant de partir, il a offert à Mag une bague — pas la bague — et lui a demandé de lui garder \"une place dans le train\"." },
      { chapter: "Chapitre VI · Mai 2025", title: "Chypre, à trois pour la première fois.", body: "Max et Mag sont venus en vacances. La Méditerranée a fait sa part. Nous sommes devenus une famille au bord de la mer.\nEli a offert à Mag une seconde bague — pour officialiser le partenariat.\nUne semaine plus tard, Mag a fait à Eli un voyage-surprise d'une journée à Chypre. Juste pour dire bonjour." },
      { chapter: "Chapitre VII · 9 juin 2025", title: "Un oui, à une petite table de Varsovie.", body: "Encore Varsovie. Mag avait dit \"pas maintenant\". Eli, têtu, a demandé quand même.\nEntre un dessert partagé et un mur peint qui disait volere è potere — vouloir, c'est pouvoir — Magdalena a dit oui.\nFin juin, Mag est venue à Chypre avec ses amies Danka et Anka. Danka a accepté d'être témoin." },
      { chapter: "Chapitre VIII · Juillet 2025", title: "Nous trois, deux chiens, un ferry de valises.", body: "Mag, Max et nos deux chiens ont déménagé à Chypre.\nBeaucoup de logistique. Paperasse, caisses d'avion, retrouvailles à l'aéroport qui ne tenaient presque pas dans le cadre. Ils y sont arrivés." },
      { chapter: "Chapitre IX · Juillet → Septembre 2025", title: "Roumanie, Malte, et aller-retours en un jour.", body: "Eli travaillait loin tout l'été. C'était dur.\nIl s'échappait à Chypre une journée pour serrer Mag et Max. Eux venaient le voir à Malte. On a fait fonctionner ça, un vol court après l'autre." },
      { chapter: "Chapitre X · Octobre 2025", title: "Libre — et un ciel de Disneyland.", body: "Mag a obtenu son divorce à Varsovie. La voie était enfin libre pour le mariage.\nNous avons fêté en famille, de la seule façon possible : Disneyland Paris." },
      { chapter: "Chapitre XI · Décembre 2025 → Janvier 2026", title: "Premier Noël. Un camping-car. Sept pays.", body: "Notre premier Noël ensemble — donc, raisonnables, nous avons loué un camping-car et traversé Italie, Autriche, Slovénie, Croatie, à nouveau l'Italie, Suisse, France.\nOn a tout mangé. On a eu froid. On a beaucoup ri. Nouvel An à Paris." },
      { chapter: "Chapitre XII · Février 2026", title: "Arménie, cœurs et jacuzzi.", body: "Saint-Valentin à deux — en Arménie. Un hall d'hôtel couvert de ballons cœur rouges. Un jacuzzi avec un autre ballon cœur rouge. Nous ne faisons pas dans la subtilité." },
      { chapter: "Chapitre XIII · 15 avril 2026", title: "Officiellement, et discrètement, nous.", body: "Nous avons signé une union civile avec deux témoins — en partie pour commencer à changer le nom de Max, en partie parce qu'Eli est têtu et ne pouvait plus attendre.\nPuis retour à Chypre, à la vie lente. Construire un foyer. Compter les jours jusqu'en mai." },
    ],
    closing: "Et en mai 2027, on se retrouve sur la plage.",
  },
  schedule: {
    overline: "La journée",
    title: "19 mai 2027 — Ammos Kalambouri, Chypre.",
    intro: "Pas de plan, pas de programme. Enfants et spontanéité bienvenus.",
    items: [
      { time: "15:30", title: "Cérémonie", place: "Plage d'Ammos Kalambouri", note: "Pieds nus dans le sable. Arrivez un peu avant si vous pouvez — et dites-nous si vous avez besoin d'aide pour venir." },
      { time: "Après", title: "Souvlaki, musique, la mer", place: "Sur la plage", note: "On s'assoit, on mange, on danse, on discute — jusqu'au coucher du soleil, ou minuit, ou ce que décide la nuit. Prenez un petit pull ; la brise se rafraîchit après le coucher du soleil." },
    ],
    mapCaption: "Plan · Plage d'Ammos Kalambouri",
    mapOpen: "Ouvrir dans Google Maps →",
    dressOverline: "Code vestimentaire (en quelque sorte)",
    dressTitle: "Officiellement : aucun. En pratique : du lin.",
    dressBody: "Mesdames — laissez robes longues, chignons et talons. Maillot de bain, robe d'été légère dans les tons de la mer ; le soleil fera votre maquillage. Messieurs — le smoking reste au placard. Lin, pantalons 7/8, chaussures élégantes et confortables, crème solaire. Pas de plastique. Juste l'île et vous.",
  },
  travel: {
    overline: "Voyage & hébergement",
    title: "Trouver Chypre.",
    intro: "Tout pour arriver facilement — et peut-être prolonger un peu.",
    tabs: { flights: "Vols", stay: "Où loger", transport: "Sur place" },
    flights: {
      title: "Aéroports",
      body: "L'aéroport international le plus proche est Larnaca (LCA, ~1h en voiture). Paphos (PFO) est plus loin. Très bien desservis depuis Londres, Paris, Athènes, Varsovie et la plupart des grands hubs européens.",
      tip: "Réserver en janvier offre généralement les tarifs les plus doux.",
    },
    stay: {
      title: "Où loger",
      body: "Nous avons préparé quelques options près du lieu pour nos invités. Dites-le dans votre RSVP si vous avez besoin d'aide pour l'hébergement — nous vous enverrons les détails directement.",
      list: [],
    },
    transport: {
      title: "Sur place",
      body: "On roule à gauche à Chypre. La voiture de location est le moyen le plus simple. Le jour J, nous organiserons des navettes depuis un point central.",
      taxi: "Chauffeurs locaux de confiance : nous partagerons les contacts plus près de la date.",
    },
    addresses: {
      title: "Adresses clés",
      venue: "Ammos Kalambouri Beach, Pegeia, Chypre",
      contact: "Pour toute question pratique : eliandmag@gmail.com",
    },
  },
  rsvp: {
    overline: "Il y aura un mariage.",
    title: "Viendrez-vous au mariage à Chypre ?",
    deadline: "Merci de répondre dans le mois suivant la réception de votre invitation.",
    intro:
      "Quand ? 19.05.2027. Où ? 📍 Plage d'Ammos Kalambouri, Chypre.\nSoyez nos invités et aidez-nous à organiser ce jour-là. Nos invités viennent de Chypre, Pologne, France, Royaume-Uni, Italie, Malte, États-Unis…",
    summary: "Récapitulatif",
    errorRequired: "Le nom et l'e-mail sont obligatoires.",
    alreadyReplied: "Déjà répondu ?",
    findMyReply: "Retrouver et modifier ma réponse",
    lookupIntro: "Tape ton nom complet — on charge ta réponse pour que tu puisses tout changer.",
    lookupPlaceholder: "ex. Anna Kowalska",
    lookupCta: "Trouver ma réponse",
    foundToast: "Trouvée — tu peux modifier ci-dessous.",
    notFoundToast: "Aucune réponse à ce nom. Vérifie l'orthographe ou remplis le formulaire ci-dessous.",
    editKicker: "Modification de ta réponse",
    editTitle: "Changement de plan ?",
    editIntro: "Ta réponse est préremplie ci-dessous. Modifie et enregistre — Andreas note, siga siga.",
    editBadge: "Modification de ta réponse existante",
    editNameHint: "Garde le même nom — c'est comme ça qu'on retrouve ta réponse.",
    editCancelledToast: "Modification annulée — formulaire vide.",
    saveEdit: "Enregistrer",
    editAgain: "Modifier à nouveau",
    errorNameMismatch: "Ce nom ne correspond pas à ta réponse initiale. Retape-le à l'identique.",
    updatedTitle: "Ta réponse a été mise à jour",
    updatedBody: "Tes modifications sont enregistrées. Andreas note, siga siga.",
    fields: {
      name: "Nom complet",
      email: "E-mail",
      attending: "Serez-vous présent·e ?",
      attendingYes: "Oui, je serai là",
      attendingNo: "Hélas, je ne pourrai pas",
      guests: "Combien serez-vous ?",
      kids: "…dont enfants",
      kidsHint: "Inclus dans le total ci-dessus",
      accommodation: "Hébergement à Chypre ?",
      accommodationNeed: "Oui — aidez-moi à trouver",
      accommodationOwn: "Non — je réserverai moi-même",
      accommodationNo: "Pas nécessaire",
      allergies: "Allergies alimentaires ?",
      arrivalDate: "Arrivée à Chypre",
      departureDate: "Départ de Chypre",
      arrivalHint: "Facultatif — utile pour organiser transferts & dîners.",
      song: "Une chanson à passer",
      songPlaceholder: "Fleetwood Mac – Dreams",
      songHint: "Artiste & titre, idéalement. On l'ajoute à la playlist.",
      message: "Un mot pour nous",
    },
    menu: {
      overline: "Menu du mariage",
      title: "Précommandez vos bouchées (facultatif).",
      intro: "Choisissez ce qui vous fait envie — sandwiches, burgers, boissons. Autant que vous voulez, on prépare pour vous. Passez si vous préférez décider le jour même.",
      empty: "Rien pour l'instant.",
      totalOne: "élément sélectionné",
      totalMany: "éléments sélectionnés",
      clear: "Vider la commande",
      add: "Ajouter",
      remove: "Retirer",
    },
    submit: "Envoyer",
    sending: "Envoi…",
    successTitle: "Merci.",
    successBody: "Votre réponse nous est bien parvenue. Nous avons hâte de vous retrouver.",
    successAnother: "Envoyer une autre réponse",
    errorGeneric: "Une erreur est survenue. Merci de réessayer.",
  },
  gallery: {
    overline: "Galerie",
    title: "Quelques images du voyage.",
    intro: "Une archive tranquille — moments partagés par nous et par vous.",
    empty: "Pas encore de photos. Après le mariage, cette page se remplira des images partagées par nos invités.",
    close: "Fermer",
    prev: "Précédente",
    next: "Suivante",
    downloadAll: "Télécharger toutes les photos",
    preparing: "Préparation du téléchargement…",
    viewGrid: "Grille",
    viewTimeline: "Chronologie",
    timelineFallback: "téléversée",
    timelineNoExifTooltip: "Pas d'horodatage d'origine \u2014 heure de téléversement utilisée",
  },
  upload: {
    overline: "Partagez vos photos",
    title: "Aidez-nous à garder le souvenir.",
    body: "Choisissez les photos de votre journée — elles apparaîtront dans la galerie en quelques secondes.",
    nameLabel: "Votre nom (facultatif)",
    choose: "Choisir des photos",
    uploading: "Téléversement…",
    successTitle: "Merci pour le partage.",
    successBody: "Vos photos rejoignent notre journal.",
    addAnother: "Partager d’autres photos",
    viewGallery: "Voir la galerie",
    errorType: "Ce format de fichier n’est pas pris en charge.",
    errorGeneric: "Le téléversement a échoué. Veuillez réessayer.",
  },
  guestbook: {
    overline: "Lettres d'amour",
    title: "Laissez-nous un mot.",
    intro: "Un petit carnet ouvert pour qui voudra nous écrire — avant, ou longtemps après.",
    nameLabel: "Votre nom",
    namePlaceholder: "Comme vous voudrez signer",
    messageLabel: "Votre message",
    messagePlaceholder: "Quelque chose de court, drôle ou sérieux — tout est bienvenu.",
    submit: "Signer le livre",
    sending: "Signature…",
    successToast: "Merci d'avoir signé notre livre.",
    errorEmpty: "Merci d'indiquer un nom et un message.",
    errorGeneric: "Impossible d'enregistrer votre mot. Réessayez.",
    emptyTitle: "Pas encore de messages.",
    emptyBody: "Soyez la première voix.",
    counter: "caractères restants",
  },
  faq: {
    overline: "FAQ",
    title: "Vraies questions, réponses légères.",
    items: [
      { q: "Y a-t-il un code vestimentaire ?", a: "Officiellement non. En pratique : laissez robes longues, smokings, talons et chignons. Mesdames — maillot de bain, robe d'été légère dans les tons de la mer ; le soleil fera votre maquillage. Messieurs — lin, pantalons 7/8, chaussures élégantes et confortables, crème solaire. Le mariage est sur la plage. Pas de plastique. Juste l'île et vous." },
      { q: "À quelle heure arriver ?", a: "Cérémonie à 15h30 sur la plage d'Ammos Kalambouri. Venez un peu avant si vous pouvez. Ensuite : on s'assoit, on mange du souvlaki, on danse, on discute jusqu'au coucher du soleil ou minuit. Prenez un petit pull — la brise se rafraîchit après." },
      { q: "Y a-t-il un programme ? Une première danse ?", a: "Non. Notre mariage n'a ni plan ni horaire. Enfants et spontanéité très bienvenus. Il y aura de belles photos, un barbecue, de la musique, la mer — et vous." },
      { q: "Pouvez-vous aider avec le voyage et le logement ?", a: "Oui. Si vous avez besoin d'un transfert ou voulez prolonger votre séjour, dites-le-nous — on aide. Notre petite équipe à Chypre, Malte, en France et en Pologne est prête. Le halloumi nous unira tous." },
      { q: "Les enfants sont-ils bienvenus ?", a: "Absolument. Amenez-les. Spontanéité bienvenue." },
      { q: "Et si je m'inquiète pour ma tenue, mes cheveux, mon maquillage ?", a: "Détendez-vous. Le soleil fera le maquillage, le vent coiffera. Pas besoin de chaussures de plage. Une robe d'été légère dans les tons de la mer sera parfaite." },
      { q: "Je n'aime pas les mariages, les cravates et les chaussures serrées.", a: "Nous non plus. Lin, jupe ou short, chemise décontractée. Oubliez les chaussures. Il y aura un barbecue et une excellente musique. Ça va aller." },
      { q: "Comment aider ?", a: "Partagez vos photos et vidéos du jour — téléversez-les ici, sur le site, pour qu'on construise un vrai album ensemble. La communauté créative parmi vous est immense ; servez-vous-en." },
      { q: "S'il manque quelque chose, à qui le dire ?", a: "Écrivez-nous ou appelez-nous. Si vous avez une idée pour améliorer ce site, dites-le — on lit tout." },
    ],
  },
  footer: {
    lineOne: "Elias & Magdalena",
    lineTwo: "19 mai 2027 · Plage d’Ammos Kalambouri · Chypre",
    lineThree: "Avec amour, en quatre langues.",
  },
  gifts: {
    kicker: "Un cadeau pour notre journée",
    title: "Aidez-nous à bâtir un foyer.",
    intro: "Votre présence est le vrai cadeau. Si vous souhaitez contribuer à notre voyage de noces, les coordonnées ci-dessous sont celles que nous préférons — virement bancaire et Revolut, sans frais de carte.",
    progressOne: "personne a déjà contribué. Merci.",
    progressMany: "personnes ont déjà contribué. Merci.",
    preferredKicker: "Notre méthode préférée",
    preferredTitle: "Virement bancaire ou Revolut.",
    preferredNote: "Sans frais de carte, sans intermédiaire. Choisissez la devise la plus avantageuse pour votre banque.",
    copyHandle: "Copier le lien",
    openRevolut: "Ouvrir",
    linkCopied: "Lien Revolut copié",
    cardKicker: "Ou, si c'est plus simple",
    cardTitle: "Payer par carte.",
    cardNote: "Un paiement sécurisé par Stripe. De petits frais s'appliquent — si vous le pouvez, les coordonnées bancaires sont plus douces pour nous deux.",
    amountLabel: "Montant",
    amountHint: "De 5 € à 5 000 €.",
    nameLabel: "Votre nom (facultatif)",
    messageLabel: "Un mot pour nous (facultatif)",
    messagePrivate: "Nous seuls le verrons — jamais visible publiquement.",
    payCta: "Continuer vers Stripe",
    opening: "Ouverture de Stripe…",
    secure: "Paiement sécurisé · Stripe · 3D-Secure",
    errAmount: "Merci d'indiquer un montant d'au moins 5 €.",
    errStart: "Impossible de démarrer le paiement. Réessayez.",
    cancelled: "Paiement annulé. Aucun débit n'a été effectué.",
    thanksTitle: "Merci.",
    thanksConfirming: "Confirmation…",
    thanksBody: "Votre cadeau nous parvient à Chypre avec un câlin. À très vite en mai.",
    thanksWait: "Un instant, Stripe confirme le paiement.",
    thanksHome: "Retour au site",
  },
  dj: {
    kicker: "La cabine du DJ",
    title: "Demandez une chanson.",
    intro: "Tapez un titre, appuyez sur envoyer. La chanson arrive sur la playlist du mariage en quelques secondes. Dansez avec nous.",
    songLabel: "Titre de la chanson (ajoutez l'artiste si possible)",
    songPlaceholder: "Dancing Queen — ABBA",
    nameLabel: "Votre prénom (facultatif — apparaît ci-dessous)",
    namePlaceholder: "Marie",
    sendCta: "Envoyer au DJ",
    sending: "Envoi…",
    helper: "Ajoutée automatiquement à la playlist Spotify · les doublons sont ignorés",
    addedKicker: "Ajoutée",
    dupKicker: "Déjà présente",
    openInSpotify: "Ouvrir",
    recentKicker: "Sur la playlist",
    recentTitle: "Récemment ajoutées par nos invités.",
    recentSuffix: "jusqu'ici",
    recentEmpty: "Aucune chanson pour l'instant. Soyez le premier.",
    by: "Par",
    toastAdded: "Sur la playlist. Merci !",
    toastDuplicate: "Déjà là — quel bon goût.",
    toastNotFound: "Introuvable sur Spotify — essayez d'ajouter l'artiste.",
    toastQueued: "Reçu !",
    errTooShort: "Tapez un titre (au moins 2 caractères).",
    errGeneric: "Un souci. Réessayez.",
    nowPlaying: "En cours",
    yourSongPlaying: "Votre chanson est jouée",
  },
  ribbon: {
    ceremonyIn: "Cérémonie dans",
    beach: "Plage d'Ammos Kalambouri",
    veryClose: "Prenez place sur le sable. La cérémonie commence bientôt.",
    nowCeremony: "Maintenant : la cérémonie. La mer fait le reste.",
    reception: "Souvlaki. Musique. La mer. À notre santé.",
    party: "Une dernière danse — la nuit décide.",
  },
  geo: {
    prompt: {
      kicker: "Où êtes-vous ?",
      title: "Partagez votre position pour un accueil personnalisé.",
      body: "Nous vous donnerons les bonnes infos selon votre distance d'Ammos Kalambouri. Cette fonctionnalité ne marche que si vous autorisez la localisation.",
      allow: "Autoriser",
      later: "Plus tard",
    },
    denied: {
      kicker: "Pas de souci",
      title: "Dommage !",
      body: "Vous pouvez toujours trouver l'itinéraire sur la page Voyage.",
      cta: "Voyage",
    },
    atVenue: {
      kicker: "Vous y êtes",
      title: "Bienvenue. Un cocktail vous attend.",
      body: "La cérémonie est à 15h30 sur la plage \u2014 suivez les fleurs.",
    },
    nearby: {
      kicker: "Presque arrivé·e",
      title: "Bienvenue à Chypre.",
      body: "Un café avant la cérémonie ? On commence à 15h30 pile sur le sable \u2014 arrivez un peu avant.",
    },
    onIsland: {
      kicker: "Sur l'île",
      title: "Vous êtes tout près.",
      body: "Cérémonie à 15h30 pile sur la plage d'Ammos Kalambouri \u2014 venez un peu avant.",
    },
    faraway: {
      kicker: "À bientôt",
      title: "Bon voyage.",
      body: "La cérémonie commence à 15h30 le 19 mai 2027 \u2014 prévoyez d'arriver un peu avant. Détails sur la page Voyage.",
    },
  },
  milestones: {
    overline: "Nos chiffres jusqu'ici",
    title: "Un amour, compté en secondes.",
    body: "Des petits chiffres qui grandissent entre nous. Du premier café aux vœux que nous prononcerons à Chypre.",
    items: {
      met: "Le jour où nous nous sommes rencontrés",
      firstDate: "Notre premier vrai rendez-vous",
      proposal: "Eli a demandé, Mag a dit oui",
      movedIn: "Le jour où nous avons emménagé ensemble",
      civilPartnership: "Notre PACS",
    },
  },
};

const el = {
  meta: { htmlLang: "el", dateLong: "Τετάρτη, 19 Μαΐου 2027" },
  landing: {
    overline: "Ένα ιδιωτικό ημερολόγιο γάμου",
    title: "Elias & Magdalena",
    subtitle: "Επιλέξτε γλώσσα",
    footer: "19 Μαΐου 2027 · Παραλία Άμμος Καλαμπούρι · Κύπρος",
  },
  gate: {
    overline: "Ιδιωτική προβολή",
    title: "Λίγα λόγια για όσους αγαπάμε.",
    body: "Ο ιστότοπος αυτός είναι αποκλειστικά για τους καλεσμένους μας. Παρακαλούμε εισάγετε τον κωδικό από την πρόσκλησή σας.",
    placeholder: "Κωδικός",
    submit: "Συνέχεια",
    error: "Λάθος κωδικός. Δοκιμάστε ξανά.",
    forgot: "Αν δεν τον βρίσκετε, επικοινωνήστε μαζί μας.",
  },
  common: { cancel: "Άκυρο", save: "Αποθήκευση", back: "Πίσω" },
  nav: { home: "Αρχική", story: "Η ιστορία μας", schedule: "Πρόγραμμα", travel: "Ταξίδι", rsvp: "RSVP", gallery: "Συλλογή", upload: "Μοιραστείτε φωτογραφίες", guestbook: "Βιβλίο επισκεπτών", faq: "FAQ", gifts: "Δώρα", dj: "DJ", menu: "Μενού", close: "Κλείσιμο", logout: "Αποσύνδεση" },
  home: {
    heroOverline: "19 · 05 · 2027  ·  Κύπρος",
    heroTitle: "Elias & Magdalena",
    heroSubtitle: "παντρεύονται",
    heroLocation: "Παραλία Άμμος Καλαμπούρι · Κύπρος",
    heroCta: "Είσοδος",
    scroll: "Κύλιση",
    countdownOverline: "Μετράμε αντίστροφα",
    countdownTitle: "Μέχρι το «ναι» μας.",
    countdownDays: "Ημέρες",
    countdownHours: "Ώρες",
    countdownMinutes: "Λεπτά",
    countdownSeconds: "Δευτερόλεπτα",
    countdownStarted: "Η μέρα είναι εδώ.",
    countdownAnnivOverline: "Μαζί",
    countdownYearOfUs: "χρόνος μαζί",
    countdownYearsOfUs: "χρόνια μαζί",
    countdownMonthOfUs: "μήνας μαζί",
    countdownMonthsOfUs: "μήνες μαζί",
    countdownDayOfUs: "μέρα μαζί",
    countdownDaysOfUs: "μέρες μαζί",
    weatherOverline: "Ο καιρός",
    weatherHistoricalTitle: "Η Κύπρος τον Μάιο.",
    weatherForecastTitle: "Η πρόγνωση για την ημέρα μας.",
    weatherHistoricalNote: "Τυπικές τιμές για το β' μισό Μαΐου στην ακτή της Κύπρου.",
    weatherForecastNote: "Ζωντανή πρόγνωση Open-Meteo · ενημέρωση ανά ώρα.",
    weatherHigh: "Μέγ.",
    weatherLow: "Ελάχ.",
    weatherSea: "Θάλασσα",
    weatherSunshine: "Ηλιοφάνεια",
    weatherRain: "Βροχή",
    weatherSunrise: "Ανατολή",
    weatherSunset: "Δύση",
    weatherUV: "Δείκτης UV",
    weatherSunny: "Ηλιόλουστα",
    weatherMostlySunny: "Κυρίως ηλιοφάνεια",
    weatherPartlyCloudy: "Λίγες νεφώσεις",
    weatherCloudy: "Νεφώσεις",
    weatherRainy: "Αναμένεται βροχή",
    weatherStormy: "Καταιγίδα",
    weatherLocation: "Άμμος Καλαμπούρι · Κύπρος",
    addToCalendar: "Προσθήκη στο ημερολόγιο",
    calendarGoogle: "Google Calendar",
    calendarApple: "Apple / iCal (.ics)",
    calendarOutlook: "Outlook",
    calendarEventTitle: "Elias & Magdalena — Γάμος",
    calendarEventDetails: "Ο γάμος των Eli & Mag στην κυπριακή ακτή. Λινό, χωρίς τακούνια, με ήλιο. Λεπτομέρειες στο site.",
    welcomeOverline: "Δύο λόγια από εμάς",
    welcomeTitle: "Χωρίς πρόγραμμα. Χωρίς παπούτσια. Η θάλασσα και εσείς.",
    welcomeBody:
      "Παντρευόμαστε σε μια ήσυχη γωνιά της κυπριακής ακτής — Eli, Mag, Max και οι άνθρωποί μας. Χωρίς παραμύθι, χωρίς πομπώδες φόρεμα, χωρίς πρώτο χορό. Λινό, σουβλάκι, ηλιοβασίλεμα, αύρα. Φέρτε τον εαυτό σας, την κάμερά σας και ένα ελαφρύ πουλόβερ για το βράδυ.",
    tipOfTheDay: "Η συμβουλή του Andreas",
    storyOverline: "Η ιστορία μας",
    storyTitle: "Από τη Βαρσοβία και τη Γαλλία στην Κύπρο — και πολλές, πολλές πτήσεις πείσματος.",
    storyBody: "Μια φιλία το 2022, δέκα εισιτήρια σε τρεις μήνες, αρνήσεις για αγάπη το 2024 και μετά πολλά ραντεβού το 2025, τρία δαχτυλίδια, δύο σκυλιά, ένας Max 11 ετών, ένας ήσυχος πολιτικός γάμος — και τώρα, η παραλία.",
    storyCta: "Διαβάστε την ιστορία μας",
    scheduleOverline: "Η μέρα",
    scheduleTitle: "Μια αργή, ηλιόλουστη γιορτή.",
    scheduleCta: "Δείτε το πρόγραμμα",
    travelOverline: "Πώς θα έρθετε",
    travelTitle: "Η Κύπρος τον Μάιο, στην πιο ήσυχη εκδοχή της.",
    travelBody: "Συγκεντρώσαμε όλα όσα χρειάζεστε — αεροδρόμια, ξενοδοχεία, μεταφορές, λεπτομέρειες.",
    travelCta: "Ταξίδι & διαμονή",
    rsvpOverline: "Παρακαλούμε απαντήστε",
    rsvpTitle: "Θα είστε δίπλα μας;",
    rsvpBody: "Παρακαλούμε απαντήστε ως την 1η Μαρτίου 2027.",
    rsvpCta: "Απαντήστε τώρα",
  },
  story: {
    overline: "Η ιστορία μας · ένα άλμπουμ",
    title: "Βαρσοβία → Κύπρος, με τον μακρύτερο δρόμο.",
    intro: "Όχι μια ταινία στιγμιοτύπων. Ένα άλμπουμ. Δεκατρία κεφάλαια, με τη σειρά, με τις φωτογραφίες που ακόμη κρατάμε στο κινητό μας.",
    closingOverline: "— Και τώρα —",
    beats: [
      { chapter: "Κεφάλαιο Ι · Σεπτέμβριος 2022", title: "Βαρσοβία, μια πρώτη φορά.", body: "Συναντηθήκαμε για πρώτη φορά στη Βαρσοβία. Γίναμε φίλοι.\nΟ Eli είχε ήδη κάτι για τη Mag — όχι αγάπη, αλλά κάτι αρκετά πεισματάρικο για να το θυμάται.\nΕπειτα, χάθηκε η επαφή." },
      { chapter: "Κεφάλαιο ΙΙ · Οκτώβριος → Δεκέμβριος 2024", title: "Ξαναβρεθήκαμε. Κάπως.", body: "Δύο χρόνια αργότερα, ο Eli άρχισε να βρίσκει δικαιολογίες για να γυρνά στη Βαρσοβία. Σε τρεις μήνες την επισκέφτηκε πάνω από δέκα φορές.\nΣτις 11 Οκτωβρίου 2024 την ερωτεύτηκε τρελά. Γιατί αυτή; Γιατί η Πολωνία; Ποιος ξέρει.\nΗ Mag δεν ήθελε άντρα στη ζωή της και του έλεγε ευγενικά «άντε χάσου». Χρειάστηκαν πολλά ταξίδια, πολλά «φιλικά» δείπνα και πολλή επιμονή — μέχρι να δεχτεί ένα πραγματικό ραντεβού." },
      { chapter: "Κεφάλαιο ΙΙΙ · Ιανουάριος 2025", title: "Πρώτα ραντεβού, και ένας τρίτος χτύπος.", body: "Ο Eli γνώρισε τον Max — τον γιο της Mag, τον τρίτο χτύπο αυτής της ιστορίας.\nΗ Mag χαλάρωσε λίγο. Δύο δείπνα στο Elixir μέσα σε μία εβδομάδα, για τα γενέθλιά της. Επιτέλους λίγο ρομαντισμός." },
      { chapter: "Κεφάλαιο IV · Φεβρουάριος 2025", title: "Πρώτος Άγιος Βαλεντίνος, και ένα χέρι στο χιόνι.", body: "Ο πρώτος μας Άγιος Βαλεντίνος στη Βαρσοβία. Σινεμά, δείπνο, όλα.\nΤην επόμενη μέρα, οι τρεις μας ταξιδέψαμε στο Γκντανσκ.\nΚάπου εκεί, κάποιος έγραψε ELI ❤ MAX στο χιόνι πάνω σε ένα παρμπρίζ. Ίσως η αγαπημένη μας φωτογραφία." },
      { chapter: "Κεφάλαιο V · Μάρτιος → Απρίλιος 2025", title: "Ένα δαχτυλίδι, και μια θέση στο τρένο.", body: "Κι άλλα ταξίδια στη Βαρσοβία. Κι άλλα ραντεβού. Ο Eli αποφάσισε να φύγει από τη Γαλλία για την Κύπρο, να ετοιμάσει σπίτι για τη νέα οικογένεια.\nΠριν φύγει, της έδωσε ένα δαχτυλίδι — όχι το δαχτυλίδι — και της ζήτησε να του κρατήσει «μια θέση στο τρένο»." },
      { chapter: "Κεφάλαιο VI · Μάιος 2025", title: "Η Κύπρος, για πρώτη φορά οι τρεις.", body: "Ο Max και η Mag ήρθαν για διακοπές. Η Μεσόγειος έκανε τα δικά της. Γίναμε οικογένεια δίπλα στη θάλασσα.\nΟ Eli έδωσε στη Mag ένα δεύτερο δαχτυλίδι — για να γίνουμε επίσημα συντρόφια.\nΜία εβδομάδα μετά, η Mag επέστρεψε ξαφνικά στην Κύπρο για μία μέρα. Απλώς για να πει γεια." },
      { chapter: "Κεφάλαιο VII · 9 Ιουνίου 2025", title: "Ένα ναι, σε ένα μικρό τραπέζι στη Βαρσοβία.", body: "Κι άλλη Βαρσοβία. Η Mag είχε πει «όχι τώρα». Ο Eli, πεισματάρης, ρώτησε ούτως ή άλλως.\nΑνάμεσα σε ένα μοιρασμένο επιδόρπιο και έναν τοίχο που έγραφε volere è potere — θέλω σημαίνει μπορώ — η Magdalena είπε ναι.\nΣτο τέλος Ιουνίου, η Mag ήρθε στην Κύπρο με τις φίλες της Danka και Anka. Η Danka δέχτηκε να γίνει μάρτυρας." },
      { chapter: "Κεφάλαιο VIII · Ιούλιος 2025", title: "Εμείς οι τρεις, δύο σκυλιά, ένα φεριμπότ βαλίτσες.", body: "Η Mag, ο Max και τα δύο μας σκυλιά μετακόμισαν στην Κύπρο.\nΠολλή γραφειοκρατία, κλουβιά για αεροπλάνο, μια συνάντηση στο αεροδρόμιο που δεν χωρούσε στο κάδρο. Τα κατάφεραν." },
      { chapter: "Κεφάλαιο IX · Ιούλιος → Σεπτέμβριος 2025", title: "Ρουμανία, Μάλτα, και ολοήμερα γυρισμοί.", body: "Ο Eli δούλευε μακριά όλο το καλοκαίρι. Ήταν δύσκολο.\nΞέφευγε στην Κύπρο για μία μέρα για να αγκαλιάσει τη Mag και τον Max. Έρχονταν και αυτοί να τον δουν στη Μάλτα. Τα κάναμε να λειτουργήσουν, μια πτήση τη φορά." },
      { chapter: "Κεφάλαιο X · Οκτώβριος 2025", title: "Ελεύθεροι — και ένας ουρανός Disneyland.", body: "Η Mag πήρε το διαζύγιό της στη Βαρσοβία. Ο δρόμος προς τον γάμο ήταν επιτέλους ανοιχτός.\nΓιορτάσαμε ως οικογένεια, με τον μόνο λογικό τρόπο: Disneyland Παρίσι." },
      { chapter: "Κεφάλαιο XI · Δεκέμβριος 2025 → Ιανουάριος 2026", title: "Πρώτα Χριστούγεννα. Ένα camper. Επτά χώρες.", body: "Τα πρώτα μας κοινά Χριστούγεννα — οπότε, σοβαροί άνθρωποι, νοικιάσαμε camper και διασχίσαμε Ιταλία, Αυστρία, Σλοβενία, Κροατία, ξανά Ιταλία, Ελβετία, Γαλλία.\nΦάγαμε τα πάντα. Παγώσαμε. Γελάσαμε πολύ. Πρωτοχρονιά στο Παρίσι." },
      { chapter: "Κεφάλαιο XII · Φεβρουάριος 2026", title: "Αρμενία, καρδιές και τζακούζι.", body: "Άγιος Βαλεντίνος των δύο — στην Αρμενία. Λόμπι ξενοδοχείου γεμάτο κόκκινες φουσκωτές καρδιές. Ένα τζακούζι με άλλη μια κόκκινη καρδιά. Δεν είμαστε διακριτικοί άνθρωποι." },
      { chapter: "Κεφάλαιο XIII · 15 Απριλίου 2026", title: "Ήσυχα, επίσημα, εμείς.", body: "Υπογράψαμε πολιτικό σύμφωνο με δύο μάρτυρες — εν μέρει για να ξεκινήσουμε να αλλάζουμε το επώνυμο του Max, εν μέρει γιατί ο Eli είναι πεισματάρης και δεν άντεξε να περιμένει.\nΕπιστροφή στην Κύπρο, στην αργή καλή ζωή. Χτίζουμε σπίτι. Μετράμε αντίστροφα για τον Μάιο." },
    ],
    closing: "Και τον Μάιο του 2027, σας περιμένουμε στην παραλία.",
  },
  schedule: {
    overline: "Η μέρα",
    title: "19 Μαΐου 2027 — Άμμος Καλαμπούρι, Κύπρος.",
    intro: "Χωρίς πρόγραμμα, χωρίς ωράριο. Παιδιά και αυθορμητισμός ευπρόσδεκτα.",
    items: [
      { time: "15:30", title: "Τελετή", place: "Παραλία Άμμος Καλαμπούρι", note: "Ξυπόλυτοι στην άμμο. Φτάστε λίγο νωρίτερα αν μπορείτε — και πείτε μας αν θέλετε βοήθεια για να έρθετε." },
      { time: "Μετά", title: "Σουβλάκι, μουσική, η θάλασσα", place: "Στην παραλία", note: "Καθόμαστε, τρώμε, χορεύουμε, κουβεντιάζουμε — ως το ηλιοβασίλεμα, τα μεσάνυχτα ή ό,τι αποφασίσει η νύχτα. Φέρτε ένα ελαφρύ μπουφάν· η αύρα δροσίζει μετά." },
    ],
    mapCaption: "Χάρτης · Παραλία Άμμος Καλαμπούρι",
    mapOpen: "Άνοιγμα στο Google Maps →",
    dressOverline: "Ενδυματολογικός κώδικας (κάπως)",
    dressTitle: "Επίσημα: κανένας. Πρακτικά: λινό.",
    dressBody: "Κυρίες — αφήστε στο σπίτι τα μακριά φορέματα, τα ψηλά τακούνια και τα φτιαγμένα μαλλιά. Μαγιό, ελαφρύ φόρεμα σε αποχρώσεις της θάλασσας — ο ήλιος θα κάνει το μακιγιάζ. Κύριοι — αφήστε το σμόκιν στην ντουλάπα. Λινό, παντελόνια 7/8, άνετα κομψά παπούτσια, αντηλιακό. Όχι πλαστικό. Μόνο το νησί κι εσείς.",
  },
  travel: {
    overline: "Ταξίδι & διαμονή",
    title: "Φτάνοντας στην Κύπρο.",
    intro: "Όλα όσα χρειάζεστε — και ίσως λίγο παραπάνω.",
    tabs: { flights: "Πτήσεις", stay: "Διαμονή", transport: "Μετακινήσεις" },
    flights: {
      title: "Αεροδρόμια",
      body: "Το πλησιέστερο διεθνές αεροδρόμιο είναι η Λάρνακα (LCA, ~1 ώρα οδικώς). Η Πάφος (PFO) είναι πιο μακριά. Καλές συνδέσεις από Λονδίνο, Παρίσι, Αθήνα, Βαρσοβία και άλλες ευρωπαϊκές πόλεις.",
      tip: "Η κράτηση τον Ιανουάριο συνήθως δίνει τις πιο ήρεμες τιμές.",
    },
    stay: {
      title: "Πού να μείνετε",
      body: "Έχουμε ετοιμάσει κάποιες επιλογές κοντά στον χώρο για τους καλεσμένους μας. Πείτε μας στο RSVP αν χρειάζεστε βοήθεια με τη διαμονή — θα σας στείλουμε τις λεπτομέρειες απευθείας.",
      list: [],
    },
    transport: {
      title: "Μετακινήσεις",
      body: "Στην Κύπρο οδηγούμε στα αριστερά. Η ενοικίαση αυτοκινήτου είναι ο πιο εύκολος τρόπος. Την ημέρα του γάμου θα οργανώσουμε λεωφορεία από κεντρικό σημείο.",
      taxi: "Τοπικοί οδηγοί εμπιστοσύνης — θα μοιραστούμε επαφές πιο κοντά στην ημερομηνία.",
    },
    addresses: {
      title: "Σημαντικές διευθύνσεις",
      venue: "Παραλία Άμμος Καλαμπούρι, Πέγεια, Κύπρος",
      contact: "Για πρακτικά: eliandmag@gmail.com",
    },
  },
  rsvp: {
    overline: "Θα γίνει γάμος.",
    title: "Θα έρθετε στον γάμο στην Κύπρο;",
    deadline: "Παρακαλούμε απαντήστε μέσα σε ένα μήνα από την παραλαβή της πρόσκλησης.",
    intro:
      "Πότε; 19.05.2027. Πού; 📍 Παραλία Άμμος Καλαμπούρι, Κύπρος.\nΓίνετε καλεσμένοι μας και βοηθήστε μας να οργανώσουμε εκείνη τη μέρα. Οι καλεσμένοι μας έρχονται από Κύπρο, Πολωνία, Γαλλία, Ηνωμένο Βασίλειο, Ιταλία, Μάλτα, ΗΠΑ…",
    summary: "Σύνοψη",
    errorRequired: "Όνομα και email απαιτούνται.",
    alreadyReplied: "Έχεις ήδη απαντήσει;",
    findMyReply: "Βρες και άλλαξε την απάντησή σου",
    lookupIntro: "Γράψε το πλήρες όνομα που έβαλες την πρώτη φορά — θα φορτώσουμε την απάντησή σου για να αλλάξεις ό,τι θες.",
    lookupPlaceholder: "π.χ. Anna Kowalska",
    lookupCta: "Βρες την απάντησή μου",
    foundToast: "Τη βρήκαμε — μπορείς να αλλάξεις οτιδήποτε παρακάτω.",
    notFoundToast: "Δεν υπάρχει απάντηση με αυτό το όνομα. Έλεγξε την ορθογραφία ή συμπλήρωσε νέα φόρμα.",
    editKicker: "Αλλαγή απάντησης",
    editTitle: "Αλλαγή σχεδίων;",
    editIntro: "Η απάντησή σου είναι προσυμπληρωμένη. Άλλαξε ό,τι θες και αποθήκευσε — ο Andreas το σημειώνει, σιγά σιγά.",
    editBadge: "Επεξεργασία της απάντησής σου",
    editNameHint: "Κράτα το ίδιο όνομα — έτσι βρίσκουμε την απάντησή σου.",
    editCancelledToast: "Ακύρωση επεξεργασίας — καθαρή φόρμα.",
    saveEdit: "Αποθήκευση",
    editAgain: "Επεξεργασία ξανά",
    errorNameMismatch: "Το όνομα δεν ταιριάζει με την αρχική απάντηση. Γράψτε το ακριβώς όπως πριν.",
    updatedTitle: "Η απάντηση ενημερώθηκε",
    updatedBody: "Οι αλλαγές αποθηκεύτηκαν. Ο Andreas τις σημείωσε, σιγά σιγά.",
    fields: {
      name: "Ονοματεπώνυμο",
      email: "Email",
      attending: "Θα έρθετε;",
      attendingYes: "Ναι, θα είμαι εκεί",
      attendingNo: "Δυστυχώς, δεν μπορώ",
      guests: "Πόσοι θα είστε;",
      kids: "…από τους οποίους παιδιά",
      kidsHint: "Συμπεριλαμβάνονται στο σύνολο παραπάνω",
      accommodation: "Διαμονή στην Κύπρο;",
      accommodationNeed: "Ναι — βοηθήστε με να βρω",
      accommodationOwn: "Όχι — θα κλείσω μόνος/η",
      accommodationNo: "Δεν χρειάζομαι",
      allergies: "Τροφικές αλλεργίες;",
      arrivalDate: "Άφιξη στην Κύπρο",
      departureDate: "Αναχώρηση από Κύπρο",
      arrivalHint: "Προαιρετικό — μας βοηθά με μεταφορές & δείπνα.",
      song: "Ένα τραγούδι για τη μέρα",
      songPlaceholder: "Fleetwood Mac – Dreams",
      songHint: "Καλλιτέχνης & τίτλος. Θα μπει στην κοινή λίστα.",
      message: "Ένα μήνυμα για εμάς",
    },
    menu: {
      overline: "Μενού γάμου",
      title: "Προπαραγγείλετε τις μπουκιές σας (προαιρετικό).",
      intro: "Επιλέξτε ό,τι σας αρέσει — σάντουιτς, μπέργκερ, ποτά. Όσα θέλετε — τα ετοιμάζουμε για εσάς. Παραλείψτε αν προτιμάτε να αποφασίσετε την ημέρα.",
      empty: "Κανένα ακόμη.",
      totalOne: "στοιχείο επιλεγμένο",
      totalMany: "στοιχεία επιλεγμένα",
      clear: "Καθαρισμός",
      add: "Προσθήκη",
      remove: "Αφαίρεση",
    },
    submit: "Αποστολή",
    sending: "Αποστολή…",
    successTitle: "Ευχαριστούμε.",
    successBody: "Η απάντησή σας μας έφτασε. Ανυπομονούμε.",
    successAnother: "Νέα απάντηση",
    errorGeneric: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
  },
  gallery: {
    overline: "Συλλογή",
    title: "Κάδρα από το ταξίδι.",
    intro: "Μια ήσυχη αρχειοθήκη — στιγμές από εμάς και από εσάς.",
    empty: "Δεν υπάρχουν ακόμη φωτογραφίες. Μετά τον γάμο, η σελίδα θα γεμίσει με στιγμές από τους καλεσμένους.",
    close: "Κλείσιμο",
    prev: "Προηγούμενη",
    next: "Επόμενη",
    downloadAll: "Λήψη όλων των φωτογραφιών",
    preparing: "Προετοιμασία λήψης…",
    viewGrid: "Πλέγμα",
    viewTimeline: "Χρονολόγιο",
    timelineFallback: "μεταφόρτωση",
    timelineNoExifTooltip: "Χωρίς αρχική σφραγίδα ώρας \u2014 χρήση ώρας μεταφόρτωσης",
  },
  upload: {
    overline: "Μοιραστείτε τις φωτογραφίες σας",
    title: "Βοηθήστε μας να κρατήσουμε την ανάμνηση.",
    body: "Επιλέξτε φωτογραφίες από τη μέρα — θα εμφανιστούν στη συλλογή σε δευτερόλεπτα.",
    nameLabel: "Το όνομά σας (προαιρετικό)",
    choose: "Επιλέξτε φωτογραφίες",
    uploading: "Μεταφόρτωση…",
    successTitle: "Ευχαριστούμε.",
    successBody: "Οι φωτογραφίες σας είναι πλέον μέρος του ημερολογίου μας.",
    addAnother: "Μοιραστείτε κι άλλες",
    viewGallery: "Δείτε τη συλλογή",
    errorType: "Μη υποστηριζόμενος τύπος αρχείου.",
    errorGeneric: "Η μεταφόρτωση απέτυχε. Δοκιμάστε ξανά.",
  },
  guestbook: {
    overline: "Ερωτικά γράμματα",
    title: "Αφήστε μας ένα μήνυμα.",
    intro: "Ένα μικρό, ανοιχτό βιβλίο για όποιον θέλει να μας γράψει — πριν ή πολύ μετά τη μέρα.",
    nameLabel: "Το όνομά σας",
    namePlaceholder: "Πώς θα θέλατε να υπογράψετε",
    messageLabel: "Το μήνυμά σας",
    messagePlaceholder: "Κάτι σύντομο, αστείο ή σοβαρό — καλοδεχούμενα όλα.",
    submit: "Υπογράψτε",
    sending: "Καταχώρηση…",
    successToast: "Ευχαριστούμε που υπογράψατε.",
    errorEmpty: "Παρακαλούμε γράψτε όνομα και μήνυμα.",
    errorGeneric: "Δεν αποθηκεύτηκε το μήνυμα. Δοκιμάστε ξανά.",
    emptyTitle: "Καμία εγγραφή ακόμη.",
    emptyBody: "Γίνετε η πρώτη φωνή.",
    counter: "χαρακτήρες μένουν",
  },
  faq: {
    overline: "FAQ",
    title: "Σοβαρές ερωτήσεις, ελαφριές απαντήσεις.",
    items: [
      { q: "Υπάρχει ενδυματολογικός κώδικας;", a: "Επίσημα, όχι. Πρακτικά: αφήστε μακριά φορέματα, σμόκιν, ψηλά τακούνια. Κυρίες — μαγιό, ελαφρύ φόρεμα σε χρώματα θάλασσας· ο ήλιος κάνει το μακιγιάζ. Κύριοι — λινό, παντελόνια 7/8, άνετα κομψά παπούτσια, αντηλιακό. Ο γάμος είναι στην παραλία. Όχι πλαστικό. Μόνο το νησί κι εσείς." },
      { q: "Τι ώρα να φτάσω;", a: "Τελετή στις 15:30 στην παραλία Άμμος Καλαμπούρι. Λίγο νωρίτερα αν μπορείτε. Μετά: καθόμαστε, σουβλάκι, χορός, κουβέντα ως το ηλιοβασίλεμα ή τα μεσάνυχτα. Φέρτε ένα ελαφρύ μπουφάν." },
      { q: "Υπάρχει πρόγραμμα; Πρώτος χορός;", a: "Όχι. Ο γάμος μας δεν έχει πρόγραμμα. Παιδιά και αυθορμητισμός πολύ ευπρόσδεκτα. Όμορφες φωτογραφίες, μπάρμπεκιου, μουσική, η θάλασσα — κι εσείς." },
      { q: "Βοηθάτε με ταξίδι και διαμονή;", a: "Ναι. Αν χρειάζεστε μεταφορά ή θέλετε να μείνετε περισσότερο, πείτε μας — βοηθάμε. Η μικρή μας ομάδα σε Κύπρο, Μάλτα, Γαλλία και Πολωνία είναι έτοιμη. Το χαλούμι θα μας ενώσει." },
      { q: "Παιδιά;", a: "Φυσικά. Φέρτε τα. Αυθορμητισμός ευπρόσδεκτος." },
      { q: "Αν αγχώνομαι για ντύσιμο, μαλλιά, μακιγιάζ;", a: "Ηρεμήστε. Ο ήλιος θα κάνει το μακιγιάζ, ο αέρας θα φτιάξει το μαλλί. Δεν χρειάζονται παπούτσια παραλίας. Ένα ελαφρύ καλοκαιρινό φόρεμα σε χρώματα θάλασσας θα είναι τέλειο." },
      { q: "Δεν μ' αρέσουν οι γάμοι, οι γραβάτες, τα στενά παπούτσια.", a: "Ούτε εμάς. Λινό, φούστα ή σορτς, casual πουκάμισο. Ξεχάστε τα παπούτσια. Μπάρμπεκιου και σπουδαία μουσική. Όλα καλά." },
      { q: "Πώς μπορώ να βοηθήσω;", a: "Μοιραστείτε τις φωτογραφίες και τα βίντεό σας — ανεβάστε τα εδώ, στον ιστότοπο, για να φτιάξουμε ένα πραγματικό άλμπουμ μαζί." },
      { q: "Αν λείπει κάτι, σε ποιον το λέω;", a: "Γράψτε ή τηλεφωνήστε όποτε θέλετε. Αν έχετε ιδέες για να γίνει καλύτερος αυτός ο ιστότοπος, πείτε μας." },
    ],
  },
  footer: {
    lineOne: "Elias & Magdalena",
    lineTwo: "19 Μαΐου 2027 · Παραλία Άμμος Καλαμπούρι · Κύπρος",
    lineThree: "Με αγάπη, σε τέσσερις γλώσσες.",
  },
  gifts: {
    kicker: "Ένα δώρο για τη μέρα μας",
    title: "Βοηθήστε μας να χτίσουμε ένα σπίτι.",
    intro: "Η παρουσία σας είναι το αληθινό δώρο. Αν θέλετε να συνεισφέρετε στο ταξίδι του μέλιτος μας, τα παρακάτω στοιχεία είναι αυτά που προτιμούμε — τραπεζική μεταφορά και Revolut φτάνουν σε εμάς χωρίς προμήθειες κάρτας.",
    progressOne: "άτομο έχει ήδη συνεισφέρει. Ευχαριστούμε.",
    progressMany: "άτομα έχουν ήδη συνεισφέρει. Ευχαριστούμε.",
    preferredKicker: "Ο τρόπος που προτιμούμε",
    preferredTitle: "Τραπεζική μεταφορά ή Revolut.",
    preferredNote: "Χωρίς προμήθειες κάρτας, χωρίς μεσάζοντες. Οποιοδήποτε νόμισμα παρακάτω — επιλέξτε αυτό που είναι πιο φθηνό για την τράπεζά σας.",
    copyHandle: "Αντιγραφή συνδέσμου",
    openRevolut: "Άνοιγμα",
    linkCopied: "Ο σύνδεσμος Revolut αντιγράφηκε",
    cardKicker: "Ή, αν είναι πιο εύκολο",
    cardTitle: "Πληρωμή με κάρτα.",
    cardNote: "Ασφαλής πληρωμή μέσω Stripe. Υπάρχει μικρή προμήθεια — αν μπορείτε, τα στοιχεία τραπέζης είναι πιο ήπια για εμάς.",
    amountLabel: "Ποσό",
    amountHint: "Οποιοδήποτε ποσό από 5 € έως 5.000 €.",
    nameLabel: "Το όνομά σας (προαιρετικό)",
    messageLabel: "Ένα ιδιωτικό μήνυμα (προαιρετικό)",
    messagePrivate: "Θα το δούμε μόνο εμείς — ποτέ δημόσια.",
    payCta: "Συνέχεια στο Stripe",
    opening: "Άνοιγμα Stripe…",
    secure: "Ασφαλής πληρωμή · Stripe · 3D-Secure",
    errAmount: "Παρακαλούμε εισάγετε ποσό τουλάχιστον 5 €.",
    errStart: "Η πληρωμή δεν ξεκίνησε. Δοκιμάστε ξανά.",
    cancelled: "Η πληρωμή ακυρώθηκε. Δεν έγινε χρέωση.",
    thanksTitle: "Ευχαριστούμε.",
    thanksConfirming: "Επιβεβαίωση…",
    thanksBody: "Το δώρο σας φτάνει στην Κύπρο με μια αγκαλιά από τους δυο μας. Τα λέμε τον Μάιο.",
    thanksWait: "Μια στιγμή, το Stripe επιβεβαιώνει.",
    thanksHome: "Επιστροφή στη σελίδα",
  },
  dj: {
    kicker: "Το DJ booth",
    title: "Ζητήστε ένα τραγούδι.",
    intro: "Γράψτε ένα τραγούδι, πατήστε αποστολή. Φτάνει στη λίστα του γάμου σε δευτερόλεπτα. Χορέψτε μαζί μας.",
    songLabel: "Τίτλος τραγουδιού (προσθέστε τον καλλιτέχνη αν μπορείτε)",
    songPlaceholder: "Dancing Queen — ABBA",
    nameLabel: "Το όνομά σας (προαιρετικό — εμφανίζεται παρακάτω)",
    namePlaceholder: "Μαρία",
    sendCta: "Αποστολή στον DJ",
    sending: "Αποστολή…",
    helper: "Προστίθεται αυτόματα στη λίστα Spotify · τα διπλά αγνοούνται",
    addedKicker: "Προστέθηκε",
    dupKicker: "Υπάρχει ήδη",
    openInSpotify: "Άνοιγμα",
    recentKicker: "Στη λίστα",
    recentTitle: "Πρόσφατα από τους καλεσμένους μας.",
    recentSuffix: "μέχρι στιγμής",
    recentEmpty: "Ακόμη κανένα τραγούδι. Γίνετε ο πρώτος.",
    by: "Από",
    toastAdded: "Στη λίστα. Ευχαριστούμε!",
    toastDuplicate: "Είναι ήδη εκεί — καλό γούστο.",
    toastNotFound: "Δεν το βρήκαμε — δοκιμάστε με τον καλλιτέχνη.",
    toastQueued: "Το λάβαμε!",
    errTooShort: "Γράψτε έναν τίτλο (τουλάχιστον 2 χαρακτήρες).",
    errGeneric: "Κάτι πήγε στραβά. Ξαναδοκιμάστε.",
    nowPlaying: "Παίζει τώρα",
    yourSongPlaying: "Παίζει το τραγούδι σας",
  },
  ribbon: {
    ceremonyIn: "Η τελετή σε",
    beach: "Παραλία Άμμος Καλαμπούρι",
    veryClose: "Βρείτε μια θέση στην άμμο. Η τελετή πλησιάζει.",
    nowCeremony: "Τώρα: η τελετή. Τα υπόλοιπα τα κάνει η θάλασσα.",
    reception: "Σουβλάκι. Μουσική. Η θάλασσα. Στην υγειά μας.",
    party: "Ένας τελευταίος χορός — η νύχτα αποφασίζει.",
  },
  geo: {
    prompt: {
      kicker: "Πού βρίσκεστε;",
      title: "Μοιραστείτε την τοποθεσία σας για ένα ξεχωριστό καλωσόρισμα.",
      body: "Θα σας δώσουμε τις σωστές πληροφορίες ανάλογα με την απόστασή σας από την Άμμος Καλαμπούρι. Δουλεύει μόνο αν επιτρέψετε την πρόσβαση στην τοποθεσία.",
      allow: "Να επιτρέπεται",
      later: "Αργότερα",
    },
    denied: {
      kicker: "Κανένα πρόβλημα",
      title: "Κρίμα!",
      body: "Μπορείτε πάντα να βρείτε οδηγίες στη σελίδα «Ταξίδι».",
      cta: "Ταξίδι",
    },
    atVenue: {
      kicker: "Ήρθατε",
      title: "Καλώς ήρθατε. Πάρτε ένα κοκτέιλ.",
      body: "Η τελετή είναι στις 15:30 στην παραλία \u2014 ακολουθήστε τα λουλούδια.",
    },
    nearby: {
      kicker: "Σχεδόν εκεί",
      title: "Καλώς ήρθατε στην Κύπρο.",
      body: "Καφέ πριν την τελετή; Ξεκινάμε στις 15:30 ακριβώς στην άμμο \u2014 έρθετε λίγο νωρίτερα.",
    },
    onIsland: {
      kicker: "Στο νησί",
      title: "Είστε σχεδόν εδώ.",
      body: "Τελετή στις 15:30 ακριβώς στην παραλία Άμμος Καλαμπούρι \u2014 έρθετε λίγο νωρίτερα.",
    },
    faraway: {
      kicker: "Τα λέμε σύντομα",
      title: "Καλό ταξίδι.",
      body: "Η τελετή ξεκινά στις 15:30 στις 19 Μαΐου 2027 \u2014 έρθετε λίγο νωρίτερα. Λεπτομέρειες στη σελίδα «Ταξίδι».",
    },
  },
  milestones: {
    overline: "Οι αριθμοί μας μέχρι τώρα",
    title: "Μια αγάπη, μετρημένη σε δευτερόλεπτα.",
    body: "Μικροί αριθμοί που μεγαλώνουν ανάμεσά μας. Από τον πρώτο καφέ μέχρι τους όρκους που θα δώσουμε στην Κύπρο.",
    items: {
      met: "Η μέρα που γνωριστήκαμε",
      firstDate: "Το πρώτο μας «κανονικό» ραντεβού",
      proposal: "Ο Elias ζήτησε, η Magdalena είπε ναι",
      movedIn: "Η μέρα που μείναμε μαζί",
      civilPartnership: "Το σύμφωνο συμβίωσής μας",
    },
  },
};

const pl = {
  meta: { htmlLang: "pl", dateLong: "Środa, 19 maja 2027" },
  landing: {
    overline: "Prywatny dziennik ślubny",
    title: "Elias & Magdalena",
    subtitle: "Wybierz język",
    footer: "19 maja 2027 · Plaża Ammos Kalambouri · Cypr",
  },
  gate: {
    overline: "Wstęp prywatny",
    title: "Kilka słów dla tych, których kochamy.",
    body: "Ta strona jest zarezerwowana dla naszych gości. Wpisz hasło z zaproszenia.",
    placeholder: "Hasło",
    submit: "Dalej",
    error: "Hasło jest nieprawidłowe. Spróbuj ponownie.",
    forgot: "Nie możesz znaleźć hasła? Napisz do nas.",
  },
  common: { cancel: "Anuluj", save: "Zapisz", back: "Wróć" },
  nav: { home: "Strona główna", story: "Nasza historia", schedule: "Plan dnia", travel: "Podróż", rsvp: "RSVP", gallery: "Galeria", upload: "Udostępnij zdjęcia", guestbook: "Księga gości", faq: "FAQ", gifts: "Prezenty", dj: "DJ", menu: "Menu", close: "Zamknij", logout: "Wyloguj się" },
  home: {
    heroOverline: "19 · 05 · 2027  ·  Cypr",
    heroTitle: "Elias & Magdalena",
    heroSubtitle: "biorą ślub",
    heroLocation: "Plaża Ammos Kalambouri · Cypr",
    heroCta: "Wejdź",
    scroll: "Przewiń",
    countdownOverline: "Odliczamy",
    countdownTitle: "Do naszego wielkiego dnia.",
    countdownDays: "Dni",
    countdownHours: "Godziny",
    countdownMinutes: "Minuty",
    countdownSeconds: "Sekundy",
    countdownStarted: "To dziś.",
    countdownAnnivOverline: "Razem",
    countdownYearOfUs: "rok razem",
    countdownYearsOfUs: "lata razem",
    countdownMonthOfUs: "miesiąc razem",
    countdownMonthsOfUs: "miesięcy razem",
    countdownDayOfUs: "dzień razem",
    countdownDaysOfUs: "dni razem",
    weatherOverline: "Pogoda",
    weatherHistoricalTitle: "Cypr w maju.",
    weatherForecastTitle: "Prognoza na nasz dzień.",
    weatherHistoricalNote: "Typowe wartości dla drugiej połowy maja na cypryjskim wybrzeżu.",
    weatherForecastNote: "Prognoza na żywo z Open-Meteo · aktualizowana co godzinę.",
    weatherHigh: "Maks.",
    weatherLow: "Min.",
    weatherSea: "Morze",
    weatherSunshine: "Nasłonecznienie",
    weatherRain: "Deszcz",
    weatherSunrise: "Wschód",
    weatherSunset: "Zachód",
    weatherUV: "Indeks UV",
    weatherSunny: "Słonecznie",
    weatherMostlySunny: "Przeważnie słonecznie",
    weatherPartlyCloudy: "Częściowe zachmurzenie",
    weatherCloudy: "Pochmurno",
    weatherRainy: "Spodziewany deszcz",
    weatherStormy: "Burza",
    weatherLocation: "Ammos Kalambouri · Cypr",
    addToCalendar: "Dodaj do kalendarza",
    calendarGoogle: "Kalendarz Google",
    calendarApple: "Apple / iCal (.ics)",
    calendarOutlook: "Outlook",
    calendarEventTitle: "Elias & Magdalena — Ślub",
    calendarEventDetails: "Ślub Eli i Mag na cypryjskim wybrzeżu. Ubiór: len, bez obcasów, przygotowani na słońce. Szczegóły na stronie.",
    welcomeOverline: "Słowo od nas",
    welcomeTitle: "Bez planu. Bez butów. Tylko morze i Wy.",
    welcomeBody:
      "Bierzemy ślub na cichym kawałku cypryjskiego wybrzeża — Eli, Mag, Max i nasi bliscy. Bez bajki, bez sukni balowej, bez pierwszego tańca. Len, souvlaki, zachód słońca, morska bryza. Weźcie ze sobą aparat i lekki sweter na wieczór.",
    tipOfTheDay: "Wskazówka Andreasa",
    storyOverline: "Nasza historia",
    storyTitle: "Z Warszawy i z Francji na Cypr — i mnóstwo upartych lotów.",
    storyBody: "Przyjaźń w 2022, dziesięć biletów w trzy miesiące, odmowy dyktowane miłością w 2024, potem mnóstwo randek w 2025, trzy pierścionki, dwa psy, jedenastoletni Max, cicha cywilna obietnica — i teraz plaża.",
    storyCta: "Przeczytaj naszą historię",
    scheduleOverline: "Ten dzień",
    scheduleTitle: "Powolne, słoneczne święto.",
    scheduleCta: "Zobacz plan dnia",
    travelOverline: "Jak dotrzeć",
    travelTitle: "Cypr w maju, w najspokojniejszej odsłonie.",
    travelBody: "Zebraliśmy wszystko, czego potrzebujesz, by dotrzeć do Ammos Kalambouri — lotniska, hotele, transport.",
    travelCta: "Podróż i nocleg",
    rsvpOverline: "Prosimy o odpowiedź",
    rsvpTitle: "Będziesz z nami?",
    rsvpBody: "Prosimy o odpowiedź do 1 marca 2027.",
    rsvpCta: "Odpowiedz",
  },
  story: {
    overline: "Nasza historia · album",
    title: "Z Warszawy na Cypr — najdłuższą drogą.",
    intro: "To nie zestaw najlepszych ujęć. To album. Trzynaście rozdziałów, po kolei, ze zdjęciami, które wciąż nosimy w telefonach.",
    closingOverline: "— A teraz —",
    beats: [
      { chapter: "Rozdział I · Wrzesień 2022", title: "Warszawa, pierwszy raz.", body: "Spotkaliśmy się po raz pierwszy w Warszawie. Zostaliśmy przyjaciółmi.\nEli miał już coś do Mag — jeszcze nie miłość, ale coś na tyle upartego, żeby to zapamiętać.\nPotem, powoli, kontakt się urwał." },
      { chapter: "Rozdział II · Październik → Grudzień 2024", title: "Znów razem. Niby.", body: "Dwa lata później Eli zaczął wymyślać preteksty, żeby latać do Warszawy. W trzy miesiące odwiedził Mag ponad dziesięć razy.\n11 października 2024 zakochał się na zabój. Dlaczego ona? Dlaczego Polska? Sam nie wiedział.\nMag z kolei nie szukała mężczyzny w swoim życiu i grzecznie pokazywała Eli drzwi. Trzeba było wielu lotów, wielu „przyjacielskich” kolacji i sporo uporu — zanim zgodziła się na prawdziwą randkę." },
      { chapter: "Rozdział III · Styczeń 2025", title: "Pierwsze randki i trzecie serce.", body: "Eli poznał Maxa — syna Mag i trzecie serce tej historii.\nMag trochę odpuściła. Dwie kolacje w Elixir w jednym tygodniu, na jej urodziny. Wreszcie odrobina romansu." },
      { chapter: "Rozdział IV · Luty 2025", title: "Pierwsze walentynki i napis na szybie.", body: "Pierwsze walentynki w Warszawie. Kino, kolacja, wszystko.\nNastępnego dnia we troje pojechaliśmy do Gdańska.\nGdzieś tam ktoś napisał ELI ❤ MAX na oszronionej szybie samochodu. To chyba nasze ulubione zdjęcie." },
      { chapter: "Rozdział V · Marzec → Kwiecień 2025", title: "Pierścionek i miejsce w pociągu.", body: "Kolejne wyjazdy do Warszawy. Kolejne randki. Eli postanowił przenieść się z Francji na Cypr, żeby zbudować dom dla nowej rodziny.\nPrzed wyjazdem dał Mag pierścionek — nie ten pierścionek — i poprosił, żeby zachowała mu „miejsce w pociągu”." },
      { chapter: "Rozdział VI · Maj 2025", title: "Cypr, pierwszy raz we troje.", body: "Max i Mag przyjechali na wakacje. Morze Śródziemne zrobiło swoje. Staliśmy się rodziną nad morzem.\nEli dał Mag drugi pierścionek — żeby oficjalnie zostać partnerami.\nTydzień później Mag zrobiła Eli jednodniową niespodziankę i wróciła na Cypr. Tak po prostu, żeby się przywitać." },
      { chapter: "Rozdział VII · 9 czerwca 2025", title: "Tak, przy małym stoliku w Warszawie.", body: "Znów Warszawa. Mag mówiła „nie teraz”. Eli, uparty, zapytał i tak.\nMiędzy wspólnym deserem a ścianą z napisem volere è potere — chcieć to móc — Magdalena powiedziała tak.\nPod koniec czerwca Mag przyleciała na Cypr z przyjaciółkami Danką i Anką. Danka zgodziła się być świadkową." },
      { chapter: "Rozdział VIII · Lipiec 2025", title: "We troje, dwa psy, walizki na pół samolotu.", body: "Mag, Max i dwa psy przeprowadzili się na Cypr.\nDużo papierów, transporterów, lotniskowych powitań, które ledwo mieściły się w kadrze. Ale udało się." },
      { chapter: "Rozdział IX · Lipiec → Wrzesień 2025", title: "Rumunia, Malta, jednodniowe powroty.", body: "Eli pracował daleko przez całe lato. Było ciężko.\nWracał na Cypr na jeden dzień, żeby przytulić Mag i Maxa. Oni przylatywali do niego na Maltę. Daliśmy radę, jeden krótki lot po drugim." },
      { chapter: "Rozdział X · Październik 2025", title: "Wolni — i niebo nad Disneylandem.", body: "Mag dostała rozwód w Warszawie. Droga do ślubu była wreszcie wolna.\nUczciliśmy to po rodzinnemu — jedynym sensownym sposobem: Disneyland Paryż." },
      { chapter: "Rozdział XI · Grudzień 2025 → Styczeń 2026", title: "Pierwsze święta. Jeden kamper. Siedem krajów.", body: "Pierwsze wspólne święta — więc, rozsądnie, wynajęliśmy kampera i przejechaliśmy Włochy, Austrię, Słowenię, Chorwację, znów Włochy, Szwajcarię i Francję.\nZjedliśmy wszystko. Marzliśmy. Dużo się śmialiśmy. Nowy Rok w Paryżu." },
      { chapter: "Rozdział XII · Luty 2026", title: "Armenia, serca i jacuzzi.", body: "Walentynki we dwoje — w Armenii. Hotelowe lobby pełne czerwonych balonów-serc. Jacuzzi z kolejnym czerwonym balonem-sercem. Nie jesteśmy subtelni." },
      { chapter: "Rozdział XIII · 15 kwietnia 2026", title: "Cicho, oficjalnie, my.", body: "Podpisaliśmy związek partnerski przy dwóch świadkach — trochę po to, żeby zacząć zmieniać nazwisko Maxa, a trochę dlatego, że Eli jest uparty i nie mógł czekać dłużej.\nA potem powrót na Cypr — do powolnego, dobrego życia. Budujemy dom. Odliczamy do maja." },
    ],
    closing: "A w maju 2027 zobaczymy się na plaży.",
  },
  schedule: {
    overline: "Ten dzień",
    title: "19 maja 2027 — Ammos Kalambouri, Cypr.",
    intro: "Bez planu, bez harmonogramu. Dzieci i spontaniczność bardzo mile widziane.",
    items: [
      { time: "15:30", title: "Ceremonia", place: "Plaża Ammos Kalambouri", note: "Boso na piasku. Jeśli możesz, przyjdź trochę wcześniej — i daj znać, jeśli potrzebujesz pomocy z dojazdem." },
      { time: "Potem", title: "Souvlaki, muzyka, morze", place: "Na plaży", note: "Siadamy, jemy, tańczymy, gadamy — do zachodu słońca, do północy, albo dopóki noc nie zdecyduje inaczej. Weź lekką kurtkę; po zmroku bryza chłodnieje." },
    ],
    mapCaption: "Mapa · Plaża Ammos Kalambouri",
    mapOpen: "Otwórz w Google Maps →",
    dressOverline: "Dress code (mniej więcej)",
    dressTitle: "Oficjalnie: brak. W praktyce: len.",
    dressBody: "Panie — zostawcie w domu długie suknie, upięcia i szpilki. Strój kąpielowy pod lekką letnią sukienkę w kolorach morza — słońce zrobi makijaż. Panowie — smoking zostaje w szafie. Len, spodnie 7/8, wygodne eleganckie buty, krem z filtrem. Bez plastiku. Tylko wyspa i Wy.",
  },
  travel: {
    overline: "Podróż i nocleg",
    title: "Cypr — jak tam dotrzeć.",
    intro: "Wszystko, żeby dojazd był prosty — i żeby kusiło zostać trochę dłużej.",
    tabs: { flights: "Loty", stay: "Gdzie spać", transport: "Komunikacja" },
    flights: {
      title: "Lotniska",
      body: "Najbliższe międzynarodowe lotnisko to Larnaka (LCA, ~1h jazdy). Paphos (PFO) jest dalej. Dobre połączenia z Londynem, Paryżem, Atenami, Warszawą i innymi miastami Europy.",
      tip: "Rezerwacja w styczniu zwykle oznacza najlepsze ceny.",
    },
    stay: {
      title: "Gdzie spać",
      body: "Przygotowaliśmy dla naszych gości kilka opcji blisko miejsca uroczystości. Zaznacz w RSVP, że potrzebujesz pomocy z noclegiem — wyślemy Ci szczegóły bezpośrednio.",
      list: [],
    },
    transport: {
      title: "Komunikacja",
      body: "Na Cyprze jeździ się lewą stroną. Wynajem auta to najprostszy sposób. W dniu ślubu zapewnimy transport z centralnego punktu.",
      taxi: "Zaufani lokalni kierowcy — kontakty udostępnimy bliżej terminu.",
    },
    addresses: {
      title: "Kluczowe adresy",
      venue: "Ammos Kalambouri Beach, Pegeia, Cypr",
      contact: "Sprawy praktyczne: eliandmag@gmail.com",
    },
  },
  rsvp: {
    overline: "Będzie wesele.",
    title: "Przyjedziesz na ślub na Cyprze?",
    deadline: "Prosimy o odpowiedź w ciągu miesiąca od otrzymania zaproszenia.",
    intro:
      "Kiedy? 19.05.2027. Gdzie? 📍 Plaża Ammos Kalambouri, Cypr.\nBądź naszym gościem i pomóż nam zaplanować ten dzień. Nasi goście przyjadą z Cypru, Polski, Francji, Wielkiej Brytanii, Włoch, Malty, USA…",
    summary: "Podsumowanie",
    errorRequired: "Imię i e-mail są wymagane.",
    alreadyReplied: "Już odpowiedziałeś?",
    findMyReply: "Znajdź i edytuj moją odpowiedź",
    lookupIntro: "Wpisz pełne imię i nazwisko, którego użyłeś — wczytamy twoją odpowiedź, żebyś mógł wszystko zmienić.",
    lookupPlaceholder: "np. Anna Kowalska",
    lookupCta: "Znajdź moją odpowiedź",
    foundToast: "Znalezione — możesz edytować poniżej.",
    notFoundToast: "Brak odpowiedzi pod tym imieniem. Sprawdź pisownię lub wypełnij formularz od nowa.",
    editKicker: "Edycja odpowiedzi",
    editTitle: "Zmiana planów?",
    editIntro: "Twoja odpowiedź jest wypełniona. Zmień co chcesz i zapisz — Andreas to zapisze, siga siga.",
    editBadge: "Edycja twojej odpowiedzi",
    editNameHint: "Zostaw to samo imię — po nim znajdujemy twoją odpowiedź.",
    editCancelledToast: "Edycja anulowana — świeży formularz.",
    saveEdit: "Zapisz zmiany",
    editAgain: "Edytuj ponownie",
    errorNameMismatch: "To imię nie zgadza się z pierwotną odpowiedzią. Wpisz je dokładnie jak wcześniej.",
    updatedTitle: "Odpowiedź zaktualizowana",
    updatedBody: "Zmiany zapisane. Andreas je odnotował, siga siga.",    fields: {
      name: "Imię i nazwisko",
      email: "E-mail",
      attending: "Przyjedziesz?",
      attendingYes: "Tak, będę",
      attendingNo: "Niestety nie mogę",
      guests: "Ile osób?",
      kids: "…w tym dzieci",
      kidsHint: "Wliczone w łączną liczbę powyżej",
      accommodation: "Nocleg na Cyprze?",
      accommodationNeed: "Tak — pomóżcie mi znaleźć",
      accommodationOwn: "Nie — zarezerwuję sam/a",
      accommodationNo: "Nie potrzebuję",
      allergies: "Alergie pokarmowe?",
      arrivalDate: "Przyjazd na Cypr",
      departureDate: "Wyjazd z Cypru",
      arrivalHint: "Opcjonalne — pomoże nam zaplanować transfery i kolacje.",
      song: "Piosenka na wesele",
      songPlaceholder: "Fleetwood Mac – Dreams",
      songHint: "Artysta i tytuł. Dodamy do wspólnej playlisty.",
      message: "Wiadomość dla nas",
    },
    menu: {
      overline: "Menu weselne",
      title: "Zamów przekąski wcześniej (opcjonalnie).",
      intro: "Wybierz, na co masz ochotę — kanapki, burgery, napoje. Tyle, ile chcesz — przygotujemy dla Ciebie. Pomiń, jeśli wolisz zdecydować na miejscu.",
      empty: "Nic jeszcze nie wybrano.",
      totalOne: "wybrany element",
      totalMany: "wybranych elementów",
      clear: "Wyczyść zamówienie",
      add: "Dodaj",
      remove: "Usuń",
    },
    submit: "Wyślij",
    sending: "Wysyłanie…",
    successTitle: "Dziękujemy.",
    successBody: "Twoja odpowiedź dotarła. Nie możemy się doczekać.",
    successAnother: "Wyślij kolejną",
    errorGeneric: "Coś poszło nie tak. Spróbuj ponownie.",
  },
  gallery: {
    overline: "Galeria",
    title: "Kadry z podróży.",
    intro: "Ciche archiwum — chwile od nas i od Was.",
    empty: "Jeszcze nie ma zdjęć. Po ślubie ta strona wypełni się kadrami od gości.",
    close: "Zamknij",
    prev: "Poprzednie",
    next: "Następne",
    downloadAll: "Pobierz wszystkie zdjęcia",
    preparing: "Przygotowywanie pobierania…",
    viewGrid: "Siatka",
    viewTimeline: "Oś czasu",
    timelineFallback: "wgrane",
    timelineNoExifTooltip: "Brak oryginalnej godziny \u2014 używamy godziny wgrania",
  },
  upload: {
    overline: "Udostępnij zdjęcia",
    title: "Pomóż nam zachować wspomnienie.",
    body: "Wybierz zdjęcia z dnia — pojawią się w galerii w kilka sekund.",
    nameLabel: "Twoje imię (opcjonalnie)",
    choose: "Wybierz zdjęcia",
    uploading: "Wysyłanie…",
    successTitle: "Dziękujemy.",
    successBody: "Twoje zdjęcia są już częścią naszego dziennika.",
    addAnother: "Udostępnij więcej",
    viewGallery: "Zobacz galerię",
    errorType: "Ten format pliku nie jest obsługiwany.",
    errorGeneric: "Wysyłanie nie powiodło się. Spróbuj jeszcze raz.",
  },
  guestbook: {
    overline: "Listy miłosne",
    title: "Zostaw nam parę słów.",
    intro: "Mały, otwarty zeszyt — dla każdego, kto zechce coś napisać, przed tym dniem albo długo po nim.",
    nameLabel: "Imię",
    namePlaceholder: "Jak chcesz się podpisać",
    messageLabel: "Wiadomość",
    messagePlaceholder: "Coś krótkiego, śmiesznego albo poważnego — wszystko mile widziane.",
    submit: "Podpisz księgę",
    sending: "Zapisywanie…",
    successToast: "Dziękujemy za wpis.",
    errorEmpty: "Wpisz imię i wiadomość.",
    errorGeneric: "Nie udało się zapisać. Spróbuj ponownie.",
    emptyTitle: "Jeszcze nie ma wpisów.",
    emptyBody: "Zostaw pierwsze słowa.",
    counter: "znaków pozostało",
  },
  faq: {
    overline: "FAQ",
    title: "Poważne pytania, lekkie odpowiedzi.",
    items: [
      { q: "Czy jest dress code?", a: "Oficjalnie — nie. W praktyce: zostawcie długie suknie, smokingi, szpilki i upięcia w domu. Panie — strój kąpielowy i lekka letnia sukienka w kolorach morza; słońce zrobi makijaż. Panowie — len, spodnie 7/8, wygodne eleganckie buty, krem z filtrem. Ślub jest na plaży. Bez plastiku. Tylko wyspa i Wy." },
      { q: "O której przyjść?", a: "Ceremonia o 15:30 na plaży Ammos Kalambouri. Przyjdźcie trochę wcześniej, jeśli możecie. Potem: siadamy, jemy souvlaki, tańczymy i rozmawiamy do zachodu słońca lub północy. Weźcie lekką kurtkę — bryza chłodnieje po zmroku." },
      { q: "Czy będzie harmonogram? Pierwszy taniec?", a: "Nie. Nasz ślub nie ma planu ani harmonogramu. Dzieci i spontaniczność bardzo mile widziane. Będą piękne zdjęcia, grill, muzyka, morze — i Wy." },
      { q: "Pomożecie z podróżą i noclegiem?", a: "Tak. Jeśli potrzebujesz transferu albo chcesz przedłużyć pobyt, daj znać — pomożemy. Nasza mała ekipa na Cyprze, Malcie, we Francji i w Polsce jest gotowa. Halloumi nas połączy." },
      { q: "Czy dzieci są mile widziane?", a: "Oczywiście. Przywieźcie je. Spontaniczność mile widziana." },
      { q: "A jeśli stresuję się o strój, fryzurę, makijaż?", a: "Wyluzuj. Słońce zrobi makijaż, wiatr ułoży fryzurę. Buty plażowe niepotrzebne. Lekka letnia sukienka w kolorach morza będzie idealna." },
      { q: "Nie lubię ślubów, krawatów i ciasnych butów.", a: "My też nie. Len, spódnica lub szorty, koszula na luzie. Zapomnij o butach. Grill i świetna muzyka. Będzie dobrze." },
      { q: "Jak mogę pomóc?", a: "Podzielcie się zdjęciami i filmami z tego dnia — wrzućcie je tutaj, na stronie, żebyśmy zbudowali razem prawdziwy album." },
      { q: "Jeśli czegoś brakuje, do kogo pisać?", a: "Napiszcie lub zadzwońcie. Jeśli macie pomysł, jak ulepszyć tę stronę, dajcie znać — czytamy wszystko." },
    ],
  },
  footer: {
    lineOne: "Elias & Magdalena",
    lineTwo: "19 maja 2027 · Plaża Ammos Kalambouri · Cypr",
    lineThree: "Z miłością, w czterech językach.",
  },
  gifts: {
    kicker: "Prezent na nasz dzień",
    title: "Pomóż nam zbudować dom.",
    intro: "Wasza obecność jest prawdziwym prezentem. Jeśli chcecie wesprzeć naszą podróż poślubną, poniższe dane są tymi, które lubimy najbardziej — przelew bankowy i Revolut docierają do nas w całości, bez prowizji karcianych.",
    progressOne: "osoba wsparła nas do tej pory. Dziękujemy.",
    progressMany: "osoby wsparły nas do tej pory. Dziękujemy.",
    preferredKicker: "Nasz preferowany sposób",
    preferredTitle: "Przelew bankowy lub Revolut.",
    preferredNote: "Bez prowizji karcianych, bez pośredników. Wybierz walutę, która jest najtańsza dla Twojego banku.",
    copyHandle: "Kopiuj link",
    openRevolut: "Otwórz",
    linkCopied: "Link Revolut skopiowany",
    cardKicker: "Albo, jeśli tak wygodniej",
    cardTitle: "Zapłać kartą.",
    cardNote: "Bezpieczna płatność przez Stripe. Naliczana jest niewielka prowizja — jeśli możesz, dane bankowe powyżej są dla nas łagodniejsze.",
    amountLabel: "Kwota",
    amountHint: "Dowolna kwota od 5 € do 5 000 €.",
    nameLabel: "Twoje imię (opcjonalnie)",
    messageLabel: "Prywatna wiadomość (opcjonalnie)",
    messagePrivate: "Zobaczymy ją tylko my — nigdy publicznie.",
    payCta: "Przejdź do Stripe",
    opening: "Otwieranie Stripe…",
    secure: "Bezpieczna płatność · Stripe · 3D-Secure",
    errAmount: "Wprowadź kwotę co najmniej 5 €.",
    errStart: "Nie udało się rozpocząć płatności. Spróbuj ponownie.",
    cancelled: "Płatność anulowana. Nie pobrano środków.",
    thanksTitle: "Dziękujemy.",
    thanksConfirming: "Potwierdzanie…",
    thanksBody: "Twój prezent dociera do nas na Cypr z uściskiem. Do zobaczenia w maju.",
    thanksWait: "Chwila, Stripe potwierdza płatność.",
    thanksHome: "Powrót do strony",
  },
  dj: {
    kicker: "DJ booth",
    title: "Poproś o piosenkę.",
    intro: "Wpisz utwór, naciśnij wyślij. W kilka sekund trafi na weselną playlistę. Zatańczcie z nami.",
    songLabel: "Tytuł utworu (dodaj artystę, jeśli możesz)",
    songPlaceholder: "Dancing Queen — ABBA",
    nameLabel: "Twoje imię (opcjonalnie — pojawi się poniżej)",
    namePlaceholder: "Marie",
    sendCta: "Wyślij do DJ-a",
    sending: "Wysyłam…",
    helper: "Automatycznie dodane do playlisty Spotify · duplikaty są pomijane",
    addedKicker: "Dodano",
    dupKicker: "Już jest",
    openInSpotify: "Otwórz",
    recentKicker: "Na playliście",
    recentTitle: "Ostatnio dodane przez naszych gości.",
    recentSuffix: "jak dotąd",
    recentEmpty: "Jeszcze żadnych utworów. Bądź pierwszy.",
    by: "Od",
    toastAdded: "Na playliście. Dziękujemy!",
    toastDuplicate: "Już tam jest — dobry gust.",
    toastNotFound: "Nie znaleźliśmy — spróbuj dodać artystę.",
    toastQueued: "Odebrano!",
    errTooShort: "Wpisz tytuł (co najmniej 2 znaki).",
    errGeneric: "Coś nie zadziałało. Spróbuj ponownie.",
    nowPlaying: "Teraz gra",
    yourSongPlaying: "Twoja piosenka gra",
  },
  ribbon: {
    ceremonyIn: "Ceremonia za",
    beach: "Plaża Ammos Kalambouri",
    veryClose: "Zajmij miejsce na piasku. Ceremonia już wkrótce.",
    nowCeremony: "Teraz: ceremonia. Resztę robi morze.",
    reception: "Souvlaki. Muzyka. Morze. Toast razem z nami.",
    party: "Ostatni taniec — noc decyduje.",
  },
  geo: {
    prompt: {
      kicker: "Gdzie jesteś?",
      title: "Udostępnij lokalizację, żeby otrzymać spersonalizowane powitanie.",
      body: "Dopasujemy informacje do Twojej odległości od Ammos Kalambouri. Ta funkcja działa tylko, jeśli zezwolisz na lokalizację.",
      allow: "Zezwól",
      later: "Później",
    },
    denied: {
      kicker: "Nie szkodzi",
      title: "Szkoda!",
      body: "Wskazówki dojazdu zawsze znajdziesz na stronie Podróż.",
      cta: "Podróż",
    },
    atVenue: {
      kicker: "Jesteś na miejscu",
      title: "Witaj. Weź drinka.",
      body: "Ceremonia o 15:30 na plaży \u2014 idź za kwiatami.",
    },
    nearby: {
      kicker: "Już prawie",
      title: "Witaj na Cyprze.",
      body: "Kawa przed ceremonią? Zaczynamy punktualnie o 15:30 na piasku \u2014 przyjdź trochę wcześniej.",
    },
    onIsland: {
      kicker: "Na wyspie",
      title: "Już prawie jesteś.",
      body: "Ceremonia punktualnie o 15:30 na plaży Ammos Kalambouri \u2014 przyjdź trochę wcześniej.",
    },
    faraway: {
      kicker: "Do zobaczenia",
      title: "Bezpiecznej podróży.",
      body: "Ceremonia zaczyna się o 15:30 dnia 19 maja 2027 \u2014 planuj przyjazd trochę wcześniej. Szczegóły na stronie Podróż.",
    },
  },
  milestones: {
    overline: "Nasze liczby jak dotąd",
    title: "Miłość mierzona w sekundach.",
    body: "Małe liczby, które rosną między nami. Od pierwszej kawy po przysięgi, które złożymy na Cyprze.",
    items: {
      met: "Dzień, w którym się poznaliśmy",
      firstDate: "Nasza pierwsza „prawdziwa\u201d randka",
      proposal: "Eli zapytał, Mag powiedziała tak",
      movedIn: "Dzień, w którym zamieszkaliśmy razem",
      civilPartnership: "Nasz związek partnerski",
    },
  },
};

export const DICTIONARIES = { en, fr, el, pl };

export function isValidLang(code) {
  return Object.prototype.hasOwnProperty.call(DICTIONARIES, code);
}
